

// import React, { useCallback, useContext, useEffect, useState } from "react";
// import axios from "axios";
// import {
//   FaEdit,
//   FaTrash,
//   FaChevronDown,
//   FaChevronUp,
//   FaEye,
//   FaPlusCircle,
//   FaReply,
//   FaCommentDots,
//   FaSearch,
//   FaTimes,
//   FaTicketAlt,
//   FaDownload,
//   FaCommentAlt,
//   FaList,
//   FaChevronLeft,
//   FaChevronRight,
// } from "react-icons/fa";
// import { XMarkIcon } from "@heroicons/react/24/solid";
// import Select from "react-select";
// import { AuthContext } from "../context/AuthContext";
// import { API_URL } from "../../Constants";
// import { toast } from "react-toastify";
// import { PlusIcon } from "lucide-react";
// import IssuesForm from "./IssuesForm";

// export default function Issues({ refreshTrigger }) {
//   const { user } = useContext(AuthContext);
//   const [issues, setIssues] = useState([]);
//   const [statuses, setStatuses] = useState([]);
//   const [labels, setLabels] = useState([]);
//   const [users, setUsers] = useState([]);
//   const [expandedIssue, setExpandedIssue] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isTicketModalOpen, setIsTicketModalOpen] = useState(false);
//   const [selectedIssue, setSelectedIssue] = useState(null);
//   const [statusUpdates, setStatusUpdates] = useState([]);
//   const [comments, setComments] = useState([]);
//   const [ticketDetails, setTicketDetails] = useState(null);
//   const [isCommentBoxOpen, setIsCommentBoxOpen] = useState(false);
//   const [newComment, setNewComment] = useState("");
//   const [isResponseModalOpen, setIsResponseModalOpen] = useState(false);
//   const [responseData, setResponseData] = useState({ content: "", files: [] });
//   const [issueResponses, setIssueResponses] = useState([]);
//   const [isViewModalOpen, setIsViewModalOpen] = useState(false);
//   const [showDeleteModal, setShowDeleteModal] = useState(false);
//   const [issueToDelete, setIssueToDelete] = useState(null);
//   const [searchParams, setSearchParams] = useState({
//     subject: "",
//     priority: "",
//     labelName: "",
//     targetUserId: "",
//     startDate: "",
//     endDate: "",
//   });
//   const [isSearching, setIsSearching] = useState(false);
//   const [showFields, setShowFields] = useState(false);
//   const [showAttachmentModal, setShowAttachmentModal] = useState(false);
//   const [currentAttachment, setCurrentAttachment] = useState(null);
//   const [attachmentType, setAttachmentType] = useState("");
//   const [attachmentFilename, setAttachmentFilename] = useState("");
//   const [pageNumber, setPageNumber] = useState(0);
//   const [pageSize, setPageSize] = useState(10);
//   const [totalPages, setTotalPages] = useState(0);
//   const [abortController, setAbortController] = useState(new AbortController());
//   const [isLoading, setIsLoading] = useState(false);
//   const [editModalData, setEditModalData] = useState(null); // response to edit
//   const [updatedContent, setUpdatedContent] = useState("");
//   const [updatedFile, setUpdatedFile] = useState(null);
//   const [currentResponseFile, setCurrentResponseFile] = useState(null);
//   const [responseFileModalOpen, setResponseFileModalOpen] = useState(false);
//   const [remarkInput, setRemarkInput] = useState("");
//   const [actionType, setActionType] = useState(""); // "APPROVED" or "REJECTED"
//   const [showRemarkInput, setShowRemarkInput] = useState(false);
//   const [editingCommentId, setEditingCommentId] = useState(null);
//   const [editedComment, setEditedComment] = useState("");
//   const [showCommentBoxId, setShowCommentBoxId] = useState(null);
//   const [commentInput, setCommentInput] = useState("");
//   const [editingComment, setEditingComment] = useState(null);
//   const token = localStorage.getItem("token");
//   const [statusUpdateModalOpen, setStatusUpdateModalOpen] = useState(false);
//   const [commentLengthError, setCommentLengthError] = useState("");
//   const [selectedStatusUpdate, setSelectedStatusUpdate] = useState({
//     issueId: null,
//     newStatus: "",
//     remark: "",
//   });
//   const [showIssueForm, setShowIssueForm] = useState(false);
//   const [editingIssue, setEditingIssue] = useState(null);

//   // Fetch Statuses & Labels
//   useEffect(() => {
//     async function fetchStatusAndLabel() {
//       const companyId =
//         user?.accountType === "COMPANY" ? user.id : user?.companyId;

//       try {
//         const statusResponse = await axios.get(
//           `${API_URL}/api/issueStatus/company/${companyId}`,
//           {
//             headers: {
//               authorization: `Bearer ${localStorage.getItem("token")}`,
//             },
//           }
//         );

//         setStatuses(statusResponse.data);
//       } catch (error) {
//         console.error("Error fetching statuses and labels:", error);
//       }
//     }
//     fetchStatusAndLabel();
//   }, [user]);

//   // Fetch Users
//   useEffect(() => {
//     async function fetchUsers() {
//       if (!user?.id || !user?.accountType) return;
//       const url =
//         user?.accountType === "COMPANY"
//           ? `${API_URL}/api/companyuser/getByUserId?userId=${user.id}&accountType=${user.accountType}`
//           : `${API_URL}/api/companyuser/getSameAndSubordinateUsers?userId=${user.id}&accountType=${user.accountType}`;

//       try {
//         const response = await axios.get(url, {
//           headers: {
//             authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         });
//         setUsers(response.data);
//       } catch (error) {
//         console.error("Error fetching users:", error);
//       }
//     }
//     fetchUsers();
//   }, [user]);

//   const handleEditClick = (issue) => {
//     setEditingIssue(issue);
//     setShowIssueForm(true);
//   };

//   const handleIssueUpdated = () => {
//     setShowIssueForm(false);
//     setEditingIssue(null);
//     fetchPage(pageNumber); // Refresh the current page
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setResponseData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleStatusChange = async (issueId, newStatus, e) => {
//     e.stopPropagation();
//     setSelectedStatusUpdate({
//       issueId,
//       newStatus,
//       remark: "",
//     });
//     setStatusUpdateModalOpen(true);
//   };

//   // Add this function to submit the status update
//   const handleStatusUpdateSubmit = async () => {
//     if (!selectedStatusUpdate.remark.trim()) {
//       toast.error("Please enter a remark");
//       return;
//     }

//     try {
//       const token = localStorage.getItem("token");
//       const response = await axios.put(
//         `${API_URL}/api/issues/updateStatus/${selectedStatusUpdate.issueId}`,
//         {
//           newStatus: selectedStatusUpdate.newStatus,
//           remark: selectedStatusUpdate.remark,
//           updatedById: user.id,
//           updatedByName: user.name,
//         },
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (response.data.status === "Successful") {
//         toast.success(response.data.message);
//         setStatusUpdateModalOpen(false);
//         fetchPage(pageNumber); // Refresh the current page
//       } else {
//         throw new Error(response.data.message);
//       }
//     } catch (error) {
//       console.error("Error updating issue status:", error);
//       toast.error(error.response?.data?.message);
//     }
//   };

//   // Handle search input changes
//   const handleSearchChange = (e) => {
//     const { name, value } = e.target;
//     setSearchParams((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   // Handle search submit
//   const handleSearchSubmit = async (e) => {
//     e.preventDefault();
//     setIsSearching(true);
//     setPageNumber(0);

//     try {
//       const companyId =
//         user?.accountType === "COMPANY" ? user.id : user?.companyId;
//       if (!companyId) return;

//       // Remove empty params
//       const params = Object.fromEntries(
//         Object.entries(searchParams).filter(([_, v]) => v !== "")
//       );

//       // Add pagination parameters
//       params.pageNumber = pageNumber;
//       params.pageSize = pageSize;

//       const response = await axios.get(
//         `${API_URL}/api/issues/search/${companyId}/${user?.id}`,
//         {
//           params,
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       );

//       setIssues(response.data.issues || []);
//       setTotalPages(response.data?.totalPages || 0);
//       toast.success(`Found ${response.data?.issues?.length || 0} results`);
//     } catch (error) {
//       console.error("Search failed:", error);
//       toast.error("Failed to search issues");
//       setIssues([]);
//       setTotalPages(0);
//     }
//   };

//   // Clear search and reset to normal view
//   const handleClearSearch = () => {
//     setIsSearching(false);
//     setSearchParams({
//       subject: "",
//       priority: "",
//       labelName: "",
//       targetUserId: "",
//       startDate: "",
//       endDate: "",
//     });
//     setPageNumber(0);
//     fetchPage(0);
//   };

//   const fetchPage = async (page) => {
//     setIsLoading(true);

//     // Cancel any pending requests
//     abortController.abort();
//     const newAbortController = new AbortController();
//     setAbortController(newAbortController);

//     try {
//       const token = localStorage.getItem("token");
//       if (!token) {
//         toast.error("Authentication token missing");
//         return;
//       }

//       let response;
//       const params = {
//         pageNumber: page,
//         pageSize: pageSize,
//       };

//       if (isSearching) {
//         const companyId =
//           user?.accountType === "COMPANY" ? user.id : user?.companyId;
//         // Add search params
//         Object.entries(searchParams).forEach(([key, value]) => {
//           if (value) params[key] = value;
//         });

//         response = await axios.get(
//           `${API_URL}/api/issues/search/${companyId}/${user?.id}`,
//           {
//             params,
//             headers: {
//               Authorization: `Bearer ${localStorage.getItem("token")}`,
//             },
//             signal: newAbortController.signal,
//           }
//         );
//       } else {
//         let endpoint = "";
//         if (!user?.id) return;

//         if (user.accountType === "COMPANY") {
//           endpoint = `${API_URL}/api/issues/company/${user.id}`;
//         } else {
//           endpoint = `${API_URL}/api/issues/forUser/${user.id}`;
//         }

//         response = await axios.get(
//           `${endpoint}?pageNumber=${page}&pageSize=${pageSize}`,
//           {
//             headers: { Authorization: `Bearer ${token}` },
//             signal: newAbortController.signal,
//           }
//         );
//       }

//       // Handle response
//       const issues = Array.isArray(response.data?.issues)
//         ? response.data.issues
//         : [];
//       const total = response.data?.totalPages || 0;

//       setIssues(issues);
//       setTotalPages(total);
//       setPageNumber(page);
//     } catch (err) {
//       if (err.name === "AbortError" || axios.isCancel(err)) return;
//       console.error("Error fetching issues:", err);
//       setIssues([]);
//       setTotalPages(0);
//       toast.error(err.response?.data?.message);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     const handleIssueCreated = () => {
//       setShowIssueForm(false);
//       setPageNumber(0);
//       fetchPage(pageNumber);
//     };

//     window.addEventListener("issueCreated", handleIssueCreated);

//     return () => {
//       window.removeEventListener("issueCreated", handleIssueCreated);
//     };
//   }, []);

//   useEffect(() => {
//     const controller = new AbortController();
//     setAbortController(controller);

//     setPageNumber(0);
//     fetchPage(0);

//     return () => {
//       controller.abort();
//     };
//   }, [pageSize, isSearching, refreshTrigger, user]);

//   const toggleDropdown = (issueId) => {
//     setExpandedIssue(expandedIssue === issueId ? null : issueId);
//   };

//   const handleViewIssue = (issue) => {
//     setSelectedIssue(issue);
//     setIsModalOpen(true);
//   };

//   const handleViewTicket = async (issue) => {
//     setSelectedIssue(issue);
//     setIsTicketModalOpen(true);

//     try {
//       const token = localStorage.getItem("token");
//       const response = await axios.get(
//         `${API_URL}/api/tickets/by-reference/${issue.issueId}?referenceType=Issue`,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );

//       const ticketData = response.data;
//       setTicketDetails(ticketData);

//       setComments(ticketData.comments || []);
//       setStatusUpdates(issue.statusUpdates || []);
//     } catch (error) {
//       console.error("Error fetching ticket details:", error);
//     }
//   };

//   const handleAddComment = async () => {
//     if (newComment.trim().length > 150) {
//       setCommentLengthError("comment must not exceed 150 characters");
//       return;
//     }

//     try {
//       await axios.post(
//         `${API_URL}/api/tickets/addComment/${ticketDetails.ticketId}`,
//         {
//           userId: user.id,
//           userName: user.name,
//           content: newComment,
//         },
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       );
//       setComments((prev) => [
//         ...prev,
//         {
//           content: newComment,
//           userName: user.name,
//           createdAt: new Date().toISOString(),
//         },
//       ]);
//       handleViewTicket();
//       setNewComment("");
//       setCommentLengthError("");
//       setIsCommentBoxOpen(false);
//     } catch (error) {
//       console.error("Failed to post comment:", error);
//     }
//   };

//   const handleCloseButton = () => {
//     setIsModalOpen(false);
//     setIsTicketModalOpen(false);
//     setIsCommentBoxOpen(false);
//     setNewComment("");
//   };

//   const handleResponseClick = (issue) => {
//     setSelectedIssue(issue);
//     setIsResponseModalOpen(true);
//   };

//   const handleFileChange = (e) => {
//     setResponseData((prev) => ({ ...prev, files: Array.from(e.target.files) }));
//   };

//   const handleResponseSubmit = async () => {
//     if (!selectedIssue) {
//       toast.error("No Issue selected.");
//       return;
//     }

//     const formData = new FormData();
//     formData.append("content", responseData.content);
//     formData.append("userId", user?.id);
//     formData.append("userName", user?.name);

//     // Append each file
//     responseData.files.forEach((file) => {
//       formData.append("files", file);
//     });

//     try {
//       const res = await fetch(
//         `${API_URL}/api/issues/addResponse/${selectedIssue?.issueId}`,
//         {
//           method: "POST",
//           body: formData,
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       );

//       const resJson = await res.json();

//       if (res.ok) {
//         toast.success(resJson.message);
//         setIsResponseModalOpen(false);
//         setResponseData({ content: "", files: [] });
//         handleViewResponse(selectedIssue.issueId);
//       } else {
//         toast.error("Failed to submit response.");
//       }
//     } catch (err) {
//       console.error("Error submitting response:", err);
//       toast.error("Something went wrong while submitting response.");
//     }
//   };

//   const handleViewResponse = async (clickedIssueId) => {
//     try {
//       const endpoint =
//         user.accountType === "COMPANY"
//           ? `${API_URL}/api/issues/company/${user.id}`
//           : `${API_URL}/api/issues/forUser/${user.id}`;

//       const response = await axios.get(endpoint, {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//           "Content-Type": "application/json",
//         },
//       });

//       const allIssues = Array.isArray(response.data.issues)
//         ? response.data.issues
//         : [];

//       // Find the selected issue using issueId
//       const foundIssue = allIssues.find(
//         (issue) => issue.issueId === clickedIssueId
//       );
//       if (!foundIssue) return;

//       // Set the issue and its responses from issue object
//       setSelectedIssue(foundIssue);
//       setIssueResponses(foundIssue.issueResponse || []);

//       // Open modal
//       setIsViewModalOpen(true);
//     } catch (error) {
//       console.error("Error in handleViewResponse:", error);
//     }
//   };

//   const handleDeleteResponse = async (responseId, issueId) => {
//     try {
//       await axios.delete(
//         `${API_URL}/api/issues/deleteResponse/${selectedIssue.issueId}/${responseId}`,
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       );

//       // Refetch issues after delete to keep UI updated
//       handleViewResponse(selectedIssue.issueId);
//     } catch (error) {
//       console.error("Error deleting response:", error);
//     }
//   };

//   const handleDeleteIssue = async (issueId) => {
//     try {
//       await axios.delete(`${API_URL}/api/issues/deleteIssue/${issueId}`, {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//         },
//       });

//       toast.success("Issue deleted successfully");
//       setShowDeleteModal(false);
//       setIssueToDelete(null);
//       fetchPage(0); // refresh issue list
//     } catch (error) {
//       console.error("Delete failed:", error);
//       toast.error(error.response?.data?.message || "Failed to delete issue");
//     }
//   };

//   const handleViewAttachment = async (issue, index = 0) => {
//     try {
//       if (!issue.attachments || issue.attachments.length === 0) {
//         toast.error("No attachments found");
//         return;
//       }

//       const fileName = issue.attachments[index];
//       const fileExtension = fileName.split(".").pop().toLowerCase();

//       // Determine type category
//       let typeCategory = "other";
//       if (["jpg", "jpeg", "png", "gif", "webp"].includes(fileExtension)) {
//         typeCategory = "image";
//       } else if (["mp4", "webm", "ogg"].includes(fileExtension)) {
//         typeCategory = "video";
//       } else if (["mp3", "wav", "ogg"].includes(fileExtension)) {
//         typeCategory = "audio";
//       } else if (fileExtension === "pdf") {
//         typeCategory = "pdf";
//       } else if (
//         ["doc", "docx", "xls", "xlsx", "ppt", "pptx"].includes(fileExtension)
//       ) {
//         typeCategory = "unsupported";
//       } else if (["txt", "csv"].includes(fileExtension)) {
//         typeCategory = "text";
//       }

//       // Show error for unsupported types
//       if (typeCategory === "unsupported") {
//         toast.error("Preview not available for this file type");
//         return;
//       }

//       // Fetch file
//       const response = await axios.get(
//         `${API_URL}/api/issues/view/${issue.issueId}/${fileName}`,
//         {
//           responseType: "blob",
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       );

//       // Create object URL
//       const blobType =
//         typeCategory === "pdf" ? "application/pdf" : response.data.type;
//       const blob = new Blob([response.data], { type: blobType });
//       const fileUrl = URL.createObjectURL(blob);

//       // If PDF on mobile, open in new tab instead of modal
//       const isMobile = window.innerWidth < 768;
//       if (typeCategory === "pdf" && isMobile) {
//         window.open(fileUrl, "_blank");
//         return;
//       }

//       setCurrentAttachment({
//         url: fileUrl,
//         type: typeCategory,
//         name: fileName,
//         index,
//         total: issue.attachments.length,
//       });
//       setAttachmentFilename(fileName);
//       setAttachmentType(typeCategory);
//       setShowAttachmentModal(true);
//     } catch (error) {
//       toast.error("Failed to view attachment");
//       console.error(error);
//     }
//   };

//   const handleDownloadAttachment = async (issue, fileName) => {
//     try {
//       if (!issue.attachments || issue.attachments.length === 0) {
//         toast.error("No attachment found");
//         return;
//       }

//       const response = await axios.get(
//         `${API_URL}/api/issues/download/${issue.issueId}/${fileName}`,
//         {
//           responseType: "blob",
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       );

//       const blob = new Blob([response.data]);
//       const url = window.URL.createObjectURL(blob);
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute("download", fileName);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(url);
//     } catch (error) {
//       toast.error("Failed to download attachment");
//       console.error(error);
//     }
//   };

//   const getOfficeViewerUrl = (fileUrl) => {
//     return `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
//       fileUrl
//     )}`;
//   };

//   const viewResponseAttachment = async (issueId, responseId, fileName) => {
//     try {
//       const fileExtension = fileName.split(".").pop().toLowerCase();

//       // Determine type category
//       let typeCategory = "other";
//       if (["jpg", "jpeg", "png", "gif", "webp"].includes(fileExtension)) {
//         typeCategory = "image";
//       } else if (["mp4", "webm", "ogg"].includes(fileExtension)) {
//         typeCategory = "video";
//       } else if (["mp3", "wav", "ogg"].includes(fileExtension)) {
//         typeCategory = "audio";
//       } else if (fileExtension === "pdf") {
//         typeCategory = "pdf";
//       } else if (
//         ["doc", "docx", "xls", "xlsx", "ppt", "pptx"].includes(fileExtension)
//       ) {
//         typeCategory = "office";
//       } else if (["txt", "csv"].includes(fileExtension)) {
//         typeCategory = "text";
//       }

//       // Fetch file
//       const response = await axios.get(
//         `${API_URL}/api/issues/viewResponseAttachment/${issueId}/${responseId}/${fileName}`,
//         {
//           responseType: "blob",
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       );

//       // Create object URL
//       const blobType =
//         typeCategory === "pdf" ? "application/pdf" : response.data.type;
//       const blob = new Blob([response.data], { type: blobType });
//       const fileUrl = URL.createObjectURL(blob);

//       // If PDF on mobile, open in new tab instead of modal
//       const isMobile = window.innerWidth < 768;
//       if (typeCategory === "pdf" && isMobile) {
//         window.open(fileUrl, "_blank");
//         return;
//       }

//       setCurrentResponseFile({
//         url: fileUrl,
//         type: typeCategory,
//         name: fileName,
//       });
//       setResponseFileModalOpen(true);
//     } catch (error) {
//       console.error("Error viewing response attachment:", error);
//       toast.error(
//         "Failed to view attachment. You can try downloading it instead."
//       );
//     }
//   };

//   const downloadResponseAttachment = async (issueId, responseId, fileName) => {
//     try {
//       const response = await axios.get(
//         `${API_URL}/api/issues/downloadResponseAttachment/${issueId}/${responseId}/${fileName}`,
//         {
//           responseType: "blob",
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       );

//       // Get filename from Content-Disposition header or use the stored filename
//       const contentDisposition = response.headers["content-disposition"];
//       let filename = fileName;
//       if (contentDisposition) {
//         const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
//         if (filenameMatch && filenameMatch[1]) {
//           filename = filenameMatch[1];
//         }
//       }

//       const blob = new Blob([response.data]);
//       const url = window.URL.createObjectURL(blob);
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute("download", filename);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(url);
//     } catch (error) {
//       console.error("Error downloading response attachment:", error);
//       toast.error("Failed to download attachment");
//     }
//   };

//   const handleEditResponse = (res) => {
//     setEditModalData(res);
//     setUpdatedContent(res.content);
//     setUpdatedFile(null); // clear previous file if any
//   };

//   const handleUpdateResponse = async () => {
//     const formData = new FormData();
//     if (updatedFile) formData.append("files", updatedFile);

//     formData.append("issueId", selectedIssue.issueId);
//     formData.append("userId", user.id);
//     formData.append("userName", user.name);
//     formData.append("content", updatedContent);

//     try {
//       await axios.put(
//         `${API_URL}/api/issues/updateResponse/${editModalData.id}`,
//         formData,
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//             "Content-Type": "multipart/form-data",
//           },
//         }
//       );

//       setEditModalData(null);
//       setUpdatedContent("");
//       setUpdatedFile(null);

//       handleViewResponse(selectedIssue.issueId); // refresh list
//     } catch (err) {
//       console.error("Error updating response:", err);
//     }
//   };

//   const handleApproveOrReject = async (issueId, newStatus, remark) => {
//     try {
//       const token = localStorage.getItem("token"); // or however you store your JWT

//       const response = await fetch(
//         `${API_URL}/api/issues/approveOrReject/${issueId}`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`, // include token here
//           },
//           body: JSON.stringify({
//             newStatus,
//             updatedById: user?.id,
//             updatedByName: user?.name,
//             remark,
//           }),
//         }
//       );

//       if (response.ok) {
//         await response.json(); // or just remove entirely if not needed
//         setSelectedIssue((prev) => ({
//           ...prev,
//           statusName: newStatus,
//         }));
//         setRemarkInput("");
//         setShowRemarkInput(false);
//       } else {
//         console.error("Failed to update issue status");
//       }
//     } catch (error) {
//       console.error("Error:", error);
//     }
//   };

//   const handleUpdateComment = async (ticketId, commentId, updatedContent) => {
//     const token = localStorage.getItem("token");

//     try {
//       const response = await axios.put(
//         `${API_URL}/api/tickets/updateComment/${ticketId}/${commentId}`,
//         updatedContent,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "text/plain",
//           },
//         }
//       );

//       // Clear editing state
//       setEditingCommentId(null);
//       setEditedComment("");

//       // Update comments list
//       const ticketData = response.data;
//       setTicketDetails(ticketData);
//       setComments(ticketData.comments || []);

//       toast.success("Comment updated successfully");
//     } catch (error) {
//       console.error("Error updating comment:", error);
//       toast.error("Failed to update comment");
//     }
//   };

//   const handleDeleteComment = async (commentId) => {
//     const token = localStorage.getItem("token");

//     try {
//       const response = await axios.delete(
//         `${API_URL}/api/tickets/deleteComment/${ticketDetails.ticketId}/${commentId}`,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       const ticketData = response.data;
//       setTicketDetails(ticketData);
//       setComments(ticketData.comments || []);
//     } catch (error) {
//       console.error("Error deleting comment:", error);
//     }
//   };

//   const toggleCommentBox = (responseId) => {
//     if (showCommentBoxId === responseId) {
//       setShowCommentBoxId(null);
//       setCommentInput("");
//       setEditingComment(null);
//     } else {
//       setShowCommentBoxId(responseId);
//       setCommentInput("");
//       setEditingComment(null);
//     }
//   };

//   // Submit or update comment
//   const submitComment = async (responseId) => {
//     if (!commentInput.trim()) return;
//     const commentId = editingComment?.commentId;

//     try {
//       const url = editingComment
//         ? `${API_URL}/api/issues/updateResponseComment/${selectedIssue.issueId}/${responseId}/${commentId}`
//         : `${API_URL}/api/issues/addResponseComment/${selectedIssue.issueId}/${responseId}`;

//       const method = editingComment ? "PUT" : "POST";

//       const bodyData = {
//         content: commentInput,
//         userId: user?.id,
//         userName: user?.name,
//       };

//       const res = await fetch(url, {
//         method,
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: editingComment ? commentInput : JSON.stringify(bodyData),
//       });

//       if (res.ok) {
//         setCommentInput("");
//         setShowCommentBoxId(null);
//         setEditingComment(null);
//         handleViewResponse(selectedIssue.issueId);
//         toast.success(editingComment ? "Comment updated!" : "Comment added!");
//       }
//     } catch (error) {
//       console.error("Error submitting comment:", error);
//     }
//   };

//   // Start editing
//   const handleEditComment = (responseId, comment) => {
//     setShowCommentBoxId(responseId);
//     setCommentInput(comment.content);
//     setEditingComment(comment);
//   };

//   // Delete comment
//   const handleDeleteResponseComment = async (responseId, commentId) => {
//     try {
//       const res = await fetch(
//         `${API_URL}/api/issues/deleteResponseComment/${selectedIssue.issueId}/${responseId}/${commentId}`,
//         {
//           method: "DELETE",
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );
//       if (res.ok) {
//         await handleViewResponse(selectedIssue.issueId);
//         toast.success("Comment deleted!");
//       }
//     } catch (error) {
//       console.error("Error deleting comment:", error);
//     }
//   };

//   const handleIssueCreated = useCallback(() => {
//     setShowIssueForm(false);
//     setEditingIssue(null);
//     fetchPage(pageNumber); // Refresh the current page
//   }, [pageNumber]);

//   const handleKeyDown = useCallback((event) => {
//     if (
//       event.key === "Escape" ||
//       (event.altKey && event.key.toLowerCase() === "c")
//     ) {
//       setShowIssueForm(false);
//     }
//   }, []);

//   useEffect(() => {
//     if (showIssueForm) {
//       document.addEventListener("keydown", handleKeyDown);
//     }
//     return () => {
//       document.removeEventListener("keydown", handleKeyDown);
//     };
//   }, [showIssueForm, handleKeyDown]);

//   useEffect(() => {
//     const handleIssueCreated = () => {
//       // Your data fetching logic here
//       fetchPage();
//     };

//     window.addEventListener("issueCreated", handleIssueCreated);

//     return () => {
//       window.removeEventListener("issueCreated", handleIssueCreated);
//     };
//   }, []);

//   return (
//     <div className="p-4 sm:p-5 bg-[#FAF8FF] cfg-font dark:bg-gray-900 dark:text-gray-100 min-h-screen rounded-lg shadow-lg">
//       <style>{`@import url('https://fonts.googleapis.com/css2?family=Sora:wght@600;700&family=Inter:wght@400;500;600&display=swap'); .cfg-heading{font-family:'Sora',sans-serif;color:#1F2937;} .cfg-font{font-family:'Inter',sans-serif;}`}</style>

//       <div className="flex flex-col gap-4 mb-5 sm:flex-row sm:justify-between sm:items-center">
//         {/* Heading: top on small, left on large */}
//         <div className="flex justify-start">
//           <h2 className="text-xl font-bold cfg-heading dark:text-white">
//             Issues Table
//           </h2>
//         </div>

//         {/* Search button: center on mobile, right on large */}
//         <div className="flex flex-wrap justify-end gap-2">
//           <button
//             type="button"
//             onClick={() => setShowIssueForm(true)}
//             className="flex items-center px-3 py-1.5 bg-[#673AB7] text-white rounded-md hover:bg-[#5E35A6] shadow-sm transition"
//           >
//             <PlusIcon className="w-5 h-5 mr-1" />
//             <span className="text-sm font-medium">Add</span>
//           </button>
//           <button
//             type="button"
//             onClick={() => setShowFields(!showFields)}
//             className="px-3 py-1.5 bg-[#673AB7] text-white hover:bg-[#5E35A6] rounded-md shadow-sm flex items-center transition text-sm font-medium"
//           >
//             {showFields ? (
//               <>
//                 <FaTimes className="mr-1.5 w-4 h-4" />
//                 Close
//               </>
//             ) : (
//               <>
//                 <FaSearch className="mr-1.5 w-4 h-4" />
//                 Search
//               </>
//             )}
//           </button>
//         </div>
//       </div>

//       {showFields && (
//         <form
//           onSubmit={handleSearchSubmit}
//           className="p-3 bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-[#E5E7EB] dark:border-gray-700 mb-5 w-full"
//         >
//           <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-3 items-end">
//             {/* Subject */}
//             <div>
//               <label className="block text-xs font-semibold mb-1 text-[#374151] dark:text-gray-200">
//                 Subject
//               </label>
//               <input
//                 type="text"
//                 name="subject"
//                 value={searchParams.subject}
//                 onChange={handleSearchChange}
//                 placeholder="Search by subject"
//                 className="w-full p-2 text-xs border border-[#E5E7EB] rounded-md bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] transition"
//               />
//             </div>

//             {/* Priority */}
//             <div>
//               <label className="block text-xs font-semibold mb-1 text-[#374151] dark:text-gray-200">
//                 Priority
//               </label>
//               <select
//                 name="priority"
//                 value={searchParams.priority}
//                 onChange={handleSearchChange}
//                 className="w-full p-2 text-xs border border-[#E5E7EB] rounded-md bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] transition"
//               >
//                 <option value="">All</option>
//                 <option value="High">High</option>
//                 <option value="Medium">Medium</option>
//                 <option value="Low">Low</option>
//               </select>
//             </div>

//             {/* Label */}
//             <div>
//               <label className="block text-xs font-semibold mb-1 text-[#374151] dark:text-gray-200">
//                 Label
//               </label>
//               <select
//                 name="labelName"
//                 value={searchParams.labelName}
//                 onChange={handleSearchChange}
//                 className="w-full p-2 text-xs border border-[#E5E7EB] rounded-md bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] transition"
//               >
//                 <option value="">All</option>
//                 {labels.map((label) => (
//                   <option key={label.id} value={label.name}>
//                     {label.name}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             {/* Created By */}
//             <div>
//               <label className="block text-xs font-semibold mb-1 text-[#374151] dark:text-gray-200">
//                 User
//               </label>
//               <select
//                 name="targetUserId"
//                 value={searchParams.targetUserId}
//                 onChange={handleSearchChange}
//                 className="w-full p-2 text-xs border border-[#E5E7EB] rounded-md bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] transition"
//               >
//                 <option value="">All</option>
//                 {users.map((user) => (
//                   <option key={user.id} value={user.id}>
//                     {user.fname} {user.lname}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             {/* Date Range */}
//             <div className="col-span-1 sm:col-span-2 md:col-span-3 xl:col-span-1">
//               <label className="block text-xs font-semibold mb-1 text-[#374151] dark:text-gray-200">
//                 Date Range
//               </label>
//               <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-2">
//                 <input
//                   type="date"
//                   name="startDate"
//                   value={searchParams.startDate}
//                   onChange={handleSearchChange}
//                   className="sm:w-1/2 mb-2 sm:mb-0 p-2 text-xs border border-[#E5E7EB] rounded-md bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] transition"
//                 />
//                 <span className="text-center sm:text-left text-xs text-[#6B7280] dark:text-gray-300">
//                   to
//                 </span>
//                 <input
//                   type="date"
//                   name="endDate"
//                   value={searchParams.endDate}
//                   onChange={handleSearchChange}
//                   className="sm:w-1/2 mt-2 sm:mt-0 p-2 text-xs border border-[#E5E7EB] rounded-md bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] transition"
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Buttons */}
//           <div className="flex justify-end gap-2 mt-3">
//             <button
//               type="submit"
//               className="px-3 py-1.5 text-xs bg-[#673AB7] text-white font-medium rounded-md hover:bg-[#5E35A6] shadow-sm transition flex items-center"
//             >
//               <FaSearch className="mr-1.5" />
//               Search
//             </button>
//             {isSearching && (
//               <button
//                 type="button"
//                 onClick={handleClearSearch}
//                 className="px-3 py-1.5 text-xs bg-[#F3F4F6] text-[#374151] font-medium rounded-md hover:bg-[#E5E7EB] transition dark:bg-gray-700 dark:text-gray-200 dark:hover:bg-gray-600 border border-[#E5E7EB] dark:border-gray-600 flex items-center"
//               >
//                 <FaTimes className="mr-1.5" />
//                 Clear
//               </button>
//             )}
//           </div>
//         </form>
//       )}

//       <div className="overflow-x-auto bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-[#E5E7EB] dark:border-gray-700">
//         <table className="w-full border-collapse text-xs">
//           <thead>
//             <tr className="bg-[#F3F4F6] dark:bg-gray-700 dark:text-white text-left text-[#6B7280]">
//               <th className="p-3 border-b border-[#E5E7EB] dark:border-gray-600 font-semibold uppercase tracking-wider">
//                 S No.
//               </th>
//               <th className="p-3 border-b border-[#E5E7EB] dark:border-gray-600 font-semibold uppercase tracking-wider">
//                 Title
//               </th>
//               <th className="p-3 border-b border-[#E5E7EB] dark:border-gray-600 font-semibold uppercase tracking-wider">
//                 Priority
//               </th>
//               <th className="p-3 border-b border-[#E5E7EB] dark:border-gray-600 font-semibold uppercase tracking-wider">
//                 Severity
//               </th>
//               <th className="p-3 border-b border-[#E5E7EB] dark:border-gray-600 font-semibold uppercase tracking-wider">
//                 Type
//               </th>
//               <th className="p-3 border-b border-[#E5E7EB] dark:border-gray-600 font-semibold uppercase tracking-wider">
//                 Assigned By
//               </th>
//               <th className="p-3 border-b border-[#E5E7EB] dark:border-gray-600 font-semibold uppercase tracking-wider">
//                 Assigned To
//               </th>
//               <th className="p-3 border-b border-[#E5E7EB] dark:border-gray-600 font-semibold uppercase tracking-wider">
//                 Reported Date
//               </th>
//               <th className="p-3 border-b border-[#E5E7EB] dark:border-gray-600 font-semibold uppercase tracking-wider">
//                 Status
//               </th>
//               <th className="p-3 border-b border-[#E5E7EB] dark:border-gray-600 font-semibold uppercase tracking-wider">
//                 Actions
//               </th>
//             </tr>
//           </thead>
//           <tbody>
//             {isLoading ? (
//               <tr>
//                 <td colSpan="10" className="text-center p-6 text-[#6B7280]">
//                   Loading...
//                 </td>
//               </tr>
//             ) : issues.length > 0 ? (
//               issues.map((issue, index) => (
//                 <React.Fragment key={issue.issueId}>
//                   <tr className="border-b border-[#E5E7EB] dark:border-gray-600 cursor-pointer hover:bg-[#F3F4F6] dark:hover:bg-gray-700 transition-colors duration-150">
//                     <td className="p-3 align-middle text-[#374151] dark:text-gray-200">
//                       <div className="flex items-center gap-2">
//                         <span className="cursor-pointer">{index + 1}</span>
//                         <FaList
//                           title="View Details"
//                           className="cursor-pointer text-[#8B5CF6] hover:text-[#673AB7] dark:hover:text-[#E9D5FF] text-sm"
//                           onClick={() => handleViewIssue(issue)}
//                         />
//                       </div>
//                     </td>

//                     {/* Title cell: flex moved into inner div so the td stays a table-cell */}
//                     <td
//                       className="p-3 align-middle cursor-pointer text-[#374151] dark:text-gray-200 font-medium"
//                       onClick={() => handleViewIssue(issue)}
//                     >
//                       <div className="flex items-center justify-between">
//                         <span>{issue.title}</span>
//                         <span
//                           onClick={(e) => {
//                             e.stopPropagation();
//                             toggleDropdown(issue.issueId);
//                           }}
//                           className="ml-2 cursor-pointer"
//                         >
//                           {expandedIssue === issue.issueId ? (
//                             <FaChevronUp className="text-[#6B7280]" />
//                           ) : (
//                             <FaChevronDown className="text-[#6B7280]" />
//                           )}
//                         </span>
//                       </div>
//                     </td>

//                     <td className="p-3 align-middle text-[#374151] dark:text-gray-200">
//                       {issue.priority}
//                     </td>
//                     <td className="p-3 align-middle text-[#374151] dark:text-gray-200">
//                       {issue.severity}
//                     </td>
//                     <td className="p-3 align-middle text-[#374151] dark:text-gray-200">
//                       {issue.type}
//                     </td>
//                     <td className="p-3 align-middle text-[#374151] dark:text-gray-200">
//                       {issue.reportedByName}
//                     </td>
//                     <td className="p-3 align-middle text-[#374151] dark:text-gray-200">
//                       {issue.assignedTo.map((assignee, idx) => (
//                         <span
//                           key={idx}
//                           className="inline-block bg-[#F3F4F6] dark:bg-gray-700 px-2 py-0.5 rounded mr-1 mb-1 text-[11px] font-medium border border-[#E5E7EB] dark:border-gray-600"
//                         >
//                           {assignee.name}
//                         </span>
//                       ))}
//                     </td>
//                     <td className="p-3 align-middle text-[#374151] dark:text-gray-200">
//                       {issue.reportedDate}
//                     </td>
//                     <td
//                       className="p-3 align-middle"
//                       onClick={(e) => e.stopPropagation()}
//                     >
//                       <select
//                         className="border border-[#E5E7EB] p-1.5 rounded bg-white text-[#374151] dark:bg-gray-800 dark:text-white dark:border-gray-600 focus:outline-none focus:ring-1 focus:ring-[#673AB7] text-xs"
//                         value={issue.statusName}
//                         onChange={(e) => {
//                           e.stopPropagation();
//                           handleStatusChange(issue.issueId, e.target.value, e);
//                         }}
//                       >
//                         {statuses
//                           .filter((status) => status.active === true)
//                           .map((status) => (
//                             <option key={status.id} value={status.name}>
//                               {status.name}
//                             </option>
//                           ))}
//                       </select>
//                     </td>

//                     {/* Actions cell: flex moved into inner div so icons align properly */}
//                     <td
//                       className="p-3 align-middle"
//                       onClick={(e) => e.stopPropagation()}
//                     >
//                       <div className="flex items-center gap-3 flex-wrap">
//                         {issue.createdById === user?.id ||
//                         user?.accountType === "COMPANY" ? (
//                           <>
//                             <FaEdit
//                               title="Edit"
//                               className="cursor-pointer text-[#8B5CF6] hover:text-[#673AB7] dark:hover:text-[#E9D5FF] text-sm"
//                               onClick={() => handleEditClick(issue)}
//                             />
//                             <FaTrash
//                               title="Delete"
//                               className="cursor-pointer text-[#EF4444] hover:text-[#B91C1C] dark:hover:text-[#FCA5A5] text-sm"
//                               onClick={() => {
//                                 setIssueToDelete(issue);
//                                 setShowDeleteModal(true);
//                               }}
//                             />
//                           </>
//                         ) : null}

//                         <FaReply
//                           title="Respond"
//                           className="cursor-pointer text-[#8B5CF6] hover:text-[#673AB7] dark:hover:text-[#E9D5FF] text-sm"
//                           onClick={() => handleResponseClick(issue)}
//                         />
//                         <FaTicketAlt
//                           title="View Ticket"
//                           className="cursor-pointer text-[#10B981] hover:text-[#059669] dark:hover:text-emerald-400 text-sm"
//                           onClick={() => handleViewTicket(issue)}
//                         />
//                         <FaCommentDots
//                           title="View Response"
//                           className="cursor-pointer text-[#8B5CF6] hover:text-[#673AB7] dark:hover:text-[#E9D5FF] text-sm"
//                           onClick={() => handleViewResponse(issue.issueId)}
//                         />

//                         {issue.attachments && issue.attachments.length > 0 && (
//                           <button
//                             onClick={(e) => {
//                               e.stopPropagation();
//                               setSelectedIssue(issue);
//                               handleViewAttachment(issue, 0);
//                             }}
//                             className="text-[#8B5CF6] hover:text-[#673AB7] dark:hover:text-[#E9D5FF] flex items-center gap-1 text-sm"
//                             title={
//                               issue.attachments.length > 1
//                                 ? `View ${issue.attachments.length} attachments`
//                                 : "View attachment"
//                             }
//                           >
//                             <FaEye />
//                             {issue.attachments.length > 1 && (
//                               <span className="text-[10px] font-bold">
//                                 {issue.attachments.length}
//                               </span>
//                             )}
//                           </button>
//                         )}
//                       </div>
//                     </td>
//                   </tr>
//                   {expandedIssue === issue.issueId && (
//                     <tr>
//                       <td
//                         colSpan="10"
//                         className="p-5 bg-[#FAF8FF] dark:bg-gray-800 border-b border-[#E5E7EB] dark:border-gray-700"
//                       >
//                         <div className="space-y-4">
//                           <div>
//                             <strong className="text-[#1F2937] dark:text-gray-200">
//                               Description:
//                             </strong>
//                             <p className="mt-1.5 whitespace-pre-wrap text-[#374151] dark:text-gray-300 text-sm">
//                               {issue.description}
//                             </p>
//                           </div>
//                           <div>
//                             <strong className="text-[#1F2937] dark:text-gray-200">
//                               Reproducible Steps:
//                             </strong>
//                             <p className="mt-1.5 whitespace-pre-wrap text-[#374151] dark:text-gray-300 text-sm">
//                               {issue.reproducibleSteps}
//                             </p>
//                           </div>
//                           {issue.tags && issue.tags.length > 0 && (
//                             <div>
//                               <strong className="text-[#1F2937] dark:text-gray-200">
//                                 Tags:
//                               </strong>
//                               <div className="flex flex-wrap gap-2 mt-2">
//                                 {issue.tags.map((tag, idx) => (
//                                   <span
//                                     key={idx}
//                                     className="px-2.5 py-1 bg-[#F3E8FF] text-[#673AB7] border border-[#E9D5FF] text-xs rounded-full font-medium dark:bg-purple-900/30 dark:border-purple-800 dark:text-purple-300"
//                                   >
//                                     {tag}
//                                   </span>
//                                 ))}
//                               </div>
//                             </div>
//                           )}
//                         </div>
//                       </td>
//                     </tr>
//                   )}
//                 </React.Fragment>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="10" className="text-center p-8 text-[#6B7280]">
//                   No records found
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* Pagination */}
//       {totalPages > 0 && (
//         <div className="mt-4 flex flex-col sm:flex-row justify-between items-center gap-4 bg-white dark:bg-gray-800 p-3 rounded-lg border border-[#E5E7EB] dark:border-gray-700 shadow-sm">
//           <div className="flex items-center gap-2 w-full sm:w-auto relative z-10">
//             <span className="text-sm text-[#374151] dark:text-gray-300 whitespace-nowrap">
//               Items per page:
//             </span>
//             <Select
//               className="w-24 text-sm"
//               classNamePrefix="select"
//               menuPortalTarget={
//                 typeof window !== "undefined" ? document.body : null
//               }
//               menuPosition="fixed"
//               styles={{
//                 control: (baseStyles, state) => {
//                   const isDark =
//                     typeof window !== "undefined" &&
//                     document.documentElement.classList.contains("dark");
//                   return {
//                     ...baseStyles,
//                     backgroundColor: isDark ? "#374151" : "#ffffff",
//                     color: isDark ? "#ffffff" : "#000000",
//                     borderColor: isDark ? "#4b5563" : "#E5E7EB",
//                     minHeight: "32px",
//                     fontSize: "0.875rem",
//                     zIndex: 10,
//                   };
//                 },
//                 singleValue: (base) => {
//                   const isDark =
//                     typeof window !== "undefined" &&
//                     document.documentElement.classList.contains("dark");
//                   return {
//                     ...base,
//                     color: isDark ? "#ffffff" : "#374151",
//                   };
//                 },
//                 menu: (base) => {
//                   const isDark =
//                     typeof window !== "undefined" &&
//                     document.documentElement.classList.contains("dark");
//                   return {
//                     ...base,
//                     backgroundColor: isDark ? "#1f2937" : "#ffffff",
//                     color: isDark ? "#ffffff" : "#000000",
//                     zIndex: 9999,
//                   };
//                 },
//                 menuPortal: (base) => ({
//                   ...base,
//                   zIndex: 9999,
//                 }),
//                 option: (base, state) => {
//                   const isDark =
//                     typeof window !== "undefined" &&
//                     document.documentElement.classList.contains("dark");
//                   return {
//                     ...base,
//                     backgroundColor: state.isFocused
//                       ? isDark
//                         ? "#4b5563"
//                         : "#F3F4F6"
//                       : isDark
//                       ? "#1f2937"
//                       : "#ffffff",
//                     color: isDark ? "#ffffff" : "#374151",
//                     cursor: "pointer",
//                   };
//                 },
//               }}
//               value={{ value: pageSize, label: pageSize.toString() }}
//               onChange={(selectedOption) => {
//                 setPageSize(Number(selectedOption.value));
//                 setPageNumber(0);
//                 fetchPage(0);
//               }}
//               options={[
//                 { value: 5, label: "5" },
//                 { value: 10, label: "10" },
//                 { value: 20, label: "20" },
//                 { value: 50, label: "50" },
//               ]}
//             />
//           </div>
//           <div className="flex flex-wrap justify-center items-center gap-2 w-full sm:w-auto">
//             <div className="flex items-center gap-2">
//               <button
//                 onClick={() => {
//                   setPageNumber(0);
//                   fetchPage(0);
//                 }}
//                 className="px-3 py-1.5 bg-[#F3E8FF] hover:bg-[#E9D5FF] text-sm font-medium text-[#673AB7] rounded disabled:opacity-50 disabled:hover:bg-[#F3E8FF] transition-colors"
//                 disabled={pageNumber === 0}
//               >
//                 First
//               </button>
//               <button
//                 onClick={() => {
//                   const newPage = Math.max(pageNumber - 1, 0);
//                   setPageNumber(newPage);
//                   fetchPage(newPage);
//                 }}
//                 className="px-3 py-1.5 bg-[#F3E8FF] hover:bg-[#E9D5FF] text-sm font-medium text-[#673AB7] rounded disabled:opacity-50 disabled:hover:bg-[#F3E8FF] transition-colors"
//                 disabled={pageNumber === 0}
//               >
//                 Prev
//               </button>
//             </div>

//             <span className="text-sm font-medium whitespace-nowrap text-[#374151] dark:text-gray-300">
//               Page {pageNumber + 1} of {totalPages}
//             </span>

//             <div className="flex items-center gap-2">
//               <button
//                 onClick={() => {
//                   const newPage = Math.min(pageNumber + 1, totalPages - 1);
//                   setPageNumber(newPage);
//                   fetchPage(newPage);
//                 }}
//                 className="px-3 py-1.5 bg-[#F3E8FF] hover:bg-[#E9D5FF] text-sm font-medium text-[#673AB7] rounded disabled:opacity-50 disabled:hover:bg-[#F3E8FF] transition-colors"
//                 disabled={pageNumber >= totalPages - 1}
//               >
//                 Next
//               </button>
//               <button
//                 onClick={() => {
//                   setPageNumber(totalPages - 1);
//                   fetchPage(totalPages - 1);
//                 }}
//                 className="px-3 py-1.5 bg-[#F3E8FF] hover:bg-[#E9D5FF] text-sm font-medium text-[#673AB7] rounded disabled:opacity-50 disabled:hover:bg-[#F3E8FF] transition-colors"
//                 disabled={pageNumber >= totalPages - 1}
//               >
//                 Last
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Issue Detail Modal */}
//       {isModalOpen && selectedIssue && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm p-2 sm:p-4">
//           <div className="bg-white dark:bg-gray-800 dark:text-white p-6 sm:p-8 rounded-xl w-full max-w-4xl mx-auto max-h-[90vh] overflow-y-auto shadow-2xl border border-[#E5E7EB] dark:border-gray-700">
//             {/* Header */}
//             <div className="flex justify-between items-center border-b border-[#E5E7EB] dark:border-gray-600 pb-4 mb-4">
//               <h2 className="text-xl sm:text-2xl font-bold cfg-heading dark:text-white">
//                 Issue Details:{" "}
//                 <span className="text-[#673AB7]">{selectedIssue.title}</span>
//               </h2>
//               <button
//                 onClick={() => setIsModalOpen(false)}
//                 className="text-[#6B7280] hover:text-[#EF4444] dark:text-gray-300 text-xl transition-colors"
//               >
//                 <FaTimes />
//               </button>
//             </div>

//             {/* Basic Info */}
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6 text-[#374151] dark:text-gray-300">
//               <div className="space-y-2">
//                 <div>
//                   <span className="font-semibold text-[#1F2937] dark:text-gray-200">
//                     Status:
//                   </span>
//                   <span className="ml-2 px-2 py-1 rounded text-xs bg-[#F3F4F6] text-[#374151] dark:bg-gray-700 dark:text-gray-200 border border-[#E5E7EB] dark:border-gray-600">
//                     {selectedIssue.statusName}
//                   </span>
//                 </div>
//                 <div>
//                   <span className="font-semibold text-[#1F2937] dark:text-gray-200">
//                     Priority:
//                   </span>{" "}
//                   {selectedIssue.priority}
//                 </div>
//                 <div>
//                   <span className="font-semibold text-[#1F2937] dark:text-gray-200">
//                     Severity:
//                   </span>{" "}
//                   {selectedIssue.severity}
//                 </div>
//                 <div>
//                   <span className="font-semibold text-[#1F2937] dark:text-gray-200">
//                     Type:
//                   </span>{" "}
//                   {selectedIssue.type}
//                 </div>
//               </div>
//               <div className="space-y-2">
//                 <div>
//                   <span className="font-semibold text-[#1F2937] dark:text-gray-200">
//                     Environment:
//                   </span>{" "}
//                   {selectedIssue.environment}
//                 </div>
//                 <div>
//                   <span className="font-semibold text-[#1F2937] dark:text-gray-200">
//                     Reported By:
//                   </span>{" "}
//                   {selectedIssue.reportedByName}
//                 </div>
//                 <div>
//                   <span className="font-semibold text-[#1F2937] dark:text-gray-200">
//                     Reported Date:
//                   </span>{" "}
//                   {selectedIssue.reportedDate}
//                 </div>
//                 <div>
//                   <span className="font-semibold text-[#1F2937] dark:text-gray-200">
//                     Expected Fix Date:
//                   </span>{" "}
//                   {selectedIssue.expectedFixDate || "Not specified"}
//                 </div>
//               </div>
//             </div>

//             {/* Description and Steps */}
//             <div className="bg-[#FAF8FF] border border-[#E5E7EB] dark:bg-gray-700 dark:border-gray-600 p-4 rounded-lg mb-4">
//               <h3 className="font-semibold mb-2 text-[#1F2937] dark:text-gray-200">
//                 Description
//               </h3>
//               <p className="whitespace-pre-wrap break-words text-[#374151] dark:text-gray-300 text-sm">
//                 {selectedIssue.description}
//               </p>
//             </div>
//             <div className="bg-[#FAF8FF] border border-[#E5E7EB] dark:bg-gray-700 dark:border-gray-600 p-4 rounded-lg mb-4">
//               <h3 className="font-semibold mb-2 text-[#1F2937] dark:text-gray-200">
//                 Reproducible Steps
//               </h3>
//               <p className="whitespace-pre-wrap break-words text-[#374151] dark:text-gray-300 text-sm">
//                 {selectedIssue.reproducibleSteps}
//               </p>
//             </div>

//             {/* Tags */}
//             {selectedIssue.tags && selectedIssue.tags.length > 0 && (
//               <div className="mb-6">
//                 <h3 className="font-semibold mb-2 text-[#1F2937] dark:text-gray-200">
//                   Tags
//                 </h3>
//                 <div className="flex flex-wrap gap-2">
//                   {selectedIssue.tags.map((tag, idx) => (
//                     <span
//                       key={idx}
//                       className="px-2 py-1 bg-[#F3E8FF] text-[#673AB7] dark:bg-purple-900 dark:text-purple-200 text-xs font-medium rounded-full"
//                     >
//                       {tag}
//                     </span>
//                   ))}
//                 </div>
//               </div>
//             )}

//             {/* Assigned To */}
//             <div className="mb-6">
//               <h3 className="font-semibold mb-2 text-[#1F2937] dark:text-gray-200">
//                 Assigned To
//               </h3>
//               <div className="flex flex-wrap gap-2">
//                 {selectedIssue.assignedTo &&
//                 selectedIssue.assignedTo.length > 0 ? (
//                   selectedIssue.assignedTo.map((assignee, idx) => (
//                     <span
//                       key={idx}
//                       className="px-3 py-1 bg-[#F3F4F6] text-[#374151] border border-[#E5E7EB] dark:bg-gray-700 dark:border-gray-600 dark:text-gray-200 rounded-full text-sm font-medium"
//                     >
//                       {assignee.name}
//                     </span>
//                   ))
//                 ) : (
//                   <span className="text-[#6B7280]">Not assigned</span>
//                 )}
//               </div>
//             </div>

//             {/* Status Updates */}
//             <div className="bg-[#FAF8FF] border border-[#E5E7EB] dark:bg-gray-700 dark:border-gray-600 rounded-lg p-4">
//               <h3 className="font-semibold mb-3 text-[#1F2937] dark:text-gray-200">
//                 Status History
//               </h3>
//               {selectedIssue.statusUpdates &&
//               selectedIssue.statusUpdates.length > 0 ? (
//                 <ul className="space-y-3">
//                   {selectedIssue.statusUpdates.map((update, idx) => (
//                     <li
//                       key={idx}
//                       className="border-l-4 border-[#8B5CF6] pl-3 py-1"
//                     >
//                       <div className="flex flex-wrap items-baseline gap-1 text-[#374151] dark:text-gray-200 text-sm">
//                         <span className="font-medium text-[#1F2937] dark:text-white">
//                           {update.updatedByName}
//                         </span>
//                         <span>changed status from</span>
//                         <span className="font-medium">
//                           {update.oldStatus || "_"}
//                         </span>
//                         <span>to</span>
//                         <span className="font-medium text-[#673AB7] dark:text-[#E9D5FF]">
//                           {update.newStatus}
//                         </span>
//                       </div>
//                       <div className="text-xs text-[#6B7280] dark:text-gray-400 mt-1">
//                         {new Date(update.updatedAt).toLocaleString()}
//                       </div>
//                       {update.remark && (
//                         <div className="text-sm mt-1 italic text-[#6B7280] dark:text-gray-400">
//                           <span className="font-medium not-italic text-[#374151] dark:text-gray-300">
//                             Remark:
//                           </span>{" "}
//                           {update.remark}
//                         </div>
//                       )}
//                     </li>
//                   ))}
//                 </ul>
//               ) : (
//                 <p className="text-[#6B7280]">No status updates available</p>
//               )}
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Ticket Modal */}
//       {isTicketModalOpen && selectedIssue && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm p-2 sm:p-4">
//           <div className="bg-white dark:bg-gray-800 dark:text-white p-6 rounded-xl w-full max-w-4xl mx-auto max-h-[90vh] overflow-y-auto shadow-xl border border-[#E5E7EB] dark:border-gray-700">
//             {/* Header */}
//             <div className="flex justify-between items-center border-b border-[#E5E7EB] dark:border-gray-700 pb-4 mb-4">
//               <h2 className="text-xl sm:text-2xl font-bold cfg-heading dark:text-white text-[#1F2937] flex items-center gap-2">
//                 🧾 Ticket Details
//               </h2>
//               <button
//                 onClick={() => setIsTicketModalOpen(false)}
//                 className="text-[#6B7280] hover:text-[#EF4444] dark:text-white text-xl transition duration-150"
//               >
//                 <FaTimes />
//               </button>
//             </div>

//             {/* Basic Info */}
//             <div className="grid grid-cols-1 sm:grid-cols-3 gap-y-2 sm:gap-4 mb-6 text-sm sm:text-base text-[#374151] dark:text-gray-200">
//               <div>
//                 <span className="font-semibold text-[#1F2937] dark:text-white">
//                   Assigned To:
//                 </span>
//                 <span className="mx-2">
//                   {selectedIssue.assignedTo?.map((u) => u.name).join(", ") ||
//                     "_"}
//                 </span>
//               </div>
//               <div>
//                 <span className="font-semibold text-[#1F2937] dark:text-white">
//                   Status:
//                 </span>
//                 <span className="mx-2">
//                   {selectedIssue.statusUpdates?.[
//                     selectedIssue.statusUpdates.length - 1
//                   ]?.newStatus === "PENDING_APPROVAL" &&
//                   selectedIssue.createdById === user?.id ? (
//                     <div className="flex items-center flex-wrap gap-2 mt-1">
//                       <span className="inline-block px-2 py-1 rounded text-xs font-medium bg-[#F3E8FF] text-[#673AB7] border border-[#E9D5FF] dark:bg-purple-900 dark:text-purple-200">
//                         {selectedIssue.statusUpdates?.[
//                           selectedIssue.statusUpdates.length - 1
//                         ]?.newStatus || "Pending"}
//                       </span>
//                       <button
//                         className="text-green-600 hover:scale-110"
//                         title="Approve"
//                         onClick={() => {
//                           setActionType("APPROVED");
//                           setShowRemarkInput(true);
//                         }}
//                       >
//                         ✅
//                       </button>
//                       <button
//                         className="text-red-600 hover:scale-110"
//                         title="Reject"
//                         onClick={() => {
//                           setActionType("REJECTED");
//                           setShowRemarkInput(true);
//                         }}
//                       >
//                         ❌
//                       </button>
//                     </div>
//                   ) : (
//                     <span className="inline-block px-2 py-1 rounded text-xs font-medium bg-[#F3F4F6] text-[#374151] border border-[#E5E7EB] dark:bg-gray-700 dark:text-gray-200 dark:border-gray-600">
//                       {selectedIssue.statusUpdates?.[
//                         selectedIssue.statusUpdates.length - 1
//                       ]?.newStatus || selectedIssue.statusName}
//                     </span>
//                   )}
//                 </span>

//                 {/* Remark Input */}
//                 {showRemarkInput && (
//                   <div className="mt-3 bg-[#FAF8FF] p-3 rounded border border-[#E5E7EB] dark:bg-gray-700 dark:border-gray-600 dark:text-white">
//                     <textarea
//                       rows="3"
//                       value={remarkInput}
//                       onChange={(e) => setRemarkInput(e.target.value)}
//                       className="w-full border border-[#E5E7EB] rounded-md p-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-600 dark:border-gray-500 dark:text-white"
//                       placeholder="Enter your remark..."
//                     />
//                     <div className="flex gap-2 mt-2">
//                       <button
//                         onClick={() =>
//                           handleApproveOrReject(
//                             selectedIssue.issueId,
//                             actionType,
//                             remarkInput
//                           )
//                         }
//                         className="bg-[#673AB7] hover:bg-[#5E35A6] text-white text-sm px-4 py-1.5 rounded-md"
//                       >
//                         Submit
//                       </button>
//                       <button
//                         onClick={() => {
//                           setRemarkInput("");
//                           setShowRemarkInput(false);
//                         }}
//                         className="bg-[#F3F4F6] hover:bg-[#E5E7EB] text-[#374151] border border-[#E5E7EB] text-sm px-4 py-1.5 rounded-md dark:bg-gray-600 dark:text-gray-200 dark:border-gray-500"
//                       >
//                         Cancel
//                       </button>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </div>

//             {/* Status + Comments */}
//             <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
//               {/* Status Updates */}
//               <div className="bg-[#FAF8FF] rounded-lg p-4 border border-[#E5E7EB] dark:bg-gray-700 dark:border-gray-600 dark:text-white">
//                 <div className="flex justify-between items-center mb-3 border-b border-[#E5E7EB] dark:border-gray-600 pb-2">
//                   <h3 className="text-base sm:text-lg font-semibold text-[#1F2937] dark:text-white">
//                     📌 Status Updates
//                   </h3>
//                 </div>
//                 <div className="max-h-[220px] overflow-y-auto pr-1.5 text-sm space-y-3">
//                   {selectedIssue.statusUpdates?.length > 0 ? (
//                     <ul className="list-none space-y-3 border-l-2 border-[#E9D5FF] pl-3 ml-1">
//                       {selectedIssue.statusUpdates.map((update, idx) => (
//                         <li key={idx} className="relative">
//                           <span className="absolute -left-[19px] top-1 w-3 h-3 bg-[#8B5CF6] rounded-full border-2 border-[#FAF8FF] dark:border-gray-700"></span>
//                           <div className="flex flex-wrap gap-1 text-[#374151] dark:text-gray-200">
//                             <span className="font-semibold text-[#1F2937] dark:text-white">
//                               {update.updatedByName}
//                             </span>
//                             <span>changed status from</span>
//                             <span className="font-medium bg-[#F3F4F6] px-1 rounded dark:bg-gray-600">
//                               {update.oldStatus}
//                             </span>
//                             <span>to</span>
//                             <span className="font-bold text-[#673AB7] dark:text-[#E9D5FF]">
//                               {update.newStatus}
//                             </span>
//                           </div>
//                           <div className="text-[#6B7280] text-xs mt-1 dark:text-gray-400">
//                             {new Date(update.updatedAt).toLocaleString()}
//                           </div>
//                           {update.remark && (
//                             <div className="text-[#374151] bg-white border border-[#E5E7EB] p-2 rounded mt-1 text-xs italic dark:bg-gray-800 dark:border-gray-600 dark:text-gray-300">
//                               <span className="font-semibold not-italic">
//                                 Remark:
//                               </span>{" "}
//                               {update.remark}
//                             </div>
//                           )}
//                         </li>
//                       ))}
//                     </ul>
//                   ) : (
//                     <p className="text-[#6B7280] dark:text-gray-400">
//                       No status updates found.
//                     </p>
//                   )}
//                 </div>
//               </div>

//               {/* Comments */}
//               <div className="bg-[#FAF8FF] rounded-lg p-4 border border-[#E5E7EB] shadow-sm dark:bg-gray-800 dark:border-gray-700">
//                 {/* Header with comment count */}
//                 <div className="flex justify-between items-center mb-3 border-b border-[#E5E7EB] dark:border-gray-700 pb-2">
//                   <div className="flex items-center space-x-2">
//                     <h3 className="text-lg font-semibold text-[#1F2937] dark:text-white">
//                       Comments
//                     </h3>
//                     <span className="bg-[#F3E8FF] text-[#673AB7] border border-[#E9D5FF] text-xs font-bold px-2.5 py-0.5 rounded-full dark:bg-purple-900 dark:text-purple-300 dark:border-purple-700">
//                       {comments.length}
//                     </span>
//                   </div>
//                   <button
//                     onClick={() => setIsCommentBoxOpen(true)}
//                     className="flex items-center space-x-1 text-[#673AB7] hover:text-[#5E35A6] dark:text-purple-400 dark:hover:text-purple-300 transition-colors bg-[#F3E8FF] px-2 py-1 rounded dark:bg-purple-900/30"
//                   >
//                     <FaPlusCircle className="text-sm" />
//                     <span className="text-xs font-semibold">Add Comment</span>
//                   </button>
//                 </div>

//                 {/* Comments list */}
//                 <div className="space-y-4 max-h-64 overflow-y-auto pr-2 scrollbar-thin scrollbar-thumb-[#E5E7EB] scrollbar-track-transparent dark:scrollbar-thumb-gray-600">
//                   {comments.length > 0 ? (
//                     comments.map((comment, idx) => (
//                       <div
//                         key={comment.commentId || idx}
//                         className="group relative p-3 bg-white rounded-lg border border-[#E5E7EB] hover:shadow-md transition-shadow dark:bg-gray-700 dark:border-gray-600"
//                       >
//                         {/* Comment content */}
//                         {editingCommentId === (comment.commentId || idx) ? (
//                           <div className="space-y-2">
//                             <textarea
//                               value={editedComment}
//                               onChange={(e) => {
//                                 if (e.target.value.length <= 150) {
//                                   setEditedComment(e.target.value);
//                                 }
//                               }}
//                               className="w-full p-2 text-sm border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-600 dark:border-gray-500 dark:text-white"
//                               rows={3}
//                               maxLength={150}
//                               autoFocus
//                             />
//                             <div className="flex justify-between items-center">
//                               <span className="text-xs text-[#6B7280] dark:text-gray-400">
//                                 {editedComment.length}/150 characters
//                               </span>
//                               {editedComment.length > 150 && (
//                                 <span className="text-xs text-[#EF4444]">
//                                   Comment must not exceed 150 characters
//                                 </span>
//                               )}
//                             </div>
//                             <div className="flex space-x-2">
//                               <button
//                                 onClick={() => {
//                                   if (editedComment.length > 150) return;
//                                   handleUpdateComment(
//                                     ticketDetails.ticketId,
//                                     comment.commentId || idx,
//                                     editedComment
//                                   );
//                                 }}
//                                 disabled={editedComment.length > 150}
//                                 className={`px-3 py-1.5 text-xs font-semibold rounded-md ${
//                                   editedComment.length > 150
//                                     ? "bg-[#F3F4F6] text-[#9CA3AF] cursor-not-allowed dark:bg-gray-600 dark:text-gray-400 border border-[#E5E7EB] dark:border-gray-500"
//                                     : "bg-[#673AB7] text-white hover:bg-[#5E35A6]"
//                                 }`}
//                               >
//                                 Update
//                               </button>
//                               <button
//                                 onClick={() => {
//                                   setEditingCommentId(null);
//                                   setEditedComment("");
//                                 }}
//                                 className="px-3 py-1.5 text-xs font-semibold text-[#374151] bg-[#F3F4F6] hover:bg-[#E5E7EB] border border-[#E5E7EB] rounded-md dark:bg-gray-600 dark:text-gray-300 dark:hover:bg-gray-500 dark:border-gray-500"
//                               >
//                                 Cancel
//                               </button>
//                             </div>
//                           </div>
//                         ) : (
//                           <>
//                             <p className="text-sm text-[#374151] dark:text-gray-200 break-words overflow-hidden">
//                               {comment.content}
//                             </p>
//                             <div className="mt-2 flex items-center justify-between">
//                               <div className="flex items-center space-x-2">
//                                 <span className="text-xs font-semibold text-[#1F2937] dark:text-gray-300">
//                                   {comment.userName}
//                                 </span>
//                                 <span className="text-xs text-[#D1D5DB] dark:text-gray-500">
//                                   •
//                                 </span>
//                                 <span className="text-xs text-[#6B7280] dark:text-gray-400">
//                                   {new Date(comment.createdAt).toLocaleString(
//                                     "en-US",
//                                     {
//                                       month: "short",
//                                       day: "numeric",
//                                       hour: "2-digit",
//                                       minute: "2-digit",
//                                     }
//                                   )}
//                                 </span>
//                               </div>
//                               {comment.userId === user?.id && (
//                                 <div className="flex space-x-2 opacity-0 group-hover:opacity-100 transition-opacity">
//                                   <button
//                                     onClick={() => {
//                                       setEditingCommentId(
//                                         comment.commentId || idx
//                                       );
//                                       setEditedComment(comment.content);
//                                     }}
//                                     className="text-[#8B5CF6] hover:text-[#673AB7] p-1 rounded-full hover:bg-[#F3E8FF] dark:hover:bg-gray-600 transition"
//                                     title="Edit"
//                                   >
//                                     <FaEdit className="w-3.5 h-3.5" />
//                                   </button>
//                                   <button
//                                     onClick={() =>
//                                       handleDeleteComment(
//                                         comment.commentId || idx
//                                       )
//                                     }
//                                     className="text-[#EF4444] hover:text-[#B91C1C] p-1 rounded-full hover:bg-[#FEF2F2] dark:hover:bg-gray-600 transition"
//                                     title="Delete"
//                                   >
//                                     <FaTrash className="w-3.5 h-3.5" />
//                                   </button>
//                                 </div>
//                               )}
//                             </div>
//                           </>
//                         )}
//                       </div>
//                     ))
//                   ) : (
//                     <div className="text-center py-6">
//                       <FaCommentAlt className="h-10 w-10 mx-auto text-[#E5E7EB] dark:text-gray-600 mb-2" />
//                       <p className="text-sm text-[#6B7280] dark:text-gray-400">
//                         No comments yet. Be the first to comment!
//                       </p>
//                     </div>
//                   )}
//                 </div>

//                 {/* Comment Input */}
//                 {isCommentBoxOpen && (
//                   <div className="mt-4 bg-white dark:bg-gray-700 p-3 rounded-lg border border-[#E5E7EB] dark:border-gray-600 shadow-sm">
//                     <textarea
//                       rows="3"
//                       value={newComment}
//                       onChange={(e) => {
//                         if (e.target.value.length <= 150) {
//                           setNewComment(e.target.value);
//                           setCommentLengthError("");
//                         } else {
//                           setCommentLengthError(
//                             "comment must not exceed 150 characters"
//                           );
//                         }
//                       }}
//                       className="w-full border border-[#E5E7EB] rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] text-sm dark:bg-gray-800 dark:border-gray-600 dark:text-white"
//                       placeholder="Write your comment..."
//                     />
//                     <div className="flex justify-between items-center mt-1">
//                       <span className="text-xs text-[#6B7280] dark:text-gray-400">
//                         {newComment.length}/150 characters
//                       </span>
//                       {commentLengthError && (
//                         <span className="text-xs text-[#EF4444]">
//                           {commentLengthError}
//                         </span>
//                       )}
//                     </div>
//                     <button
//                       onClick={handleAddComment}
//                       disabled={newComment.length > 150}
//                       className={`mt-2 bg-[#673AB7] hover:bg-[#5E35A6] text-white text-sm font-semibold px-4 py-1.5 rounded-md transition w-full sm:w-auto ${
//                         newComment.length > 150
//                           ? "opacity-50 cursor-not-allowed"
//                           : ""
//                       }`}
//                     >
//                       Submit Comment
//                     </button>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Add Issue Form Modal */}
//       {showIssueForm && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm px-4 sm:px-6 lg:px-8">
//           <div className="relative w-full max-w-md sm:max-w-lg md:max-w-xl lg:max-w-3xl max-h-[90vh] bg-white dark:bg-gray-800 rounded-xl shadow-2xl transition-all duration-300 transform scale-100 flex flex-col border border-[#E5E7EB] dark:border-gray-700">
//             <div className="sticky top-0 z-20 flex items-center justify-between bg-white dark:bg-gray-800 p-4 border-b border-[#E5E7EB] dark:border-gray-700 rounded-t-xl">
//               <h2 className="text-xl font-bold cfg-heading text-[#1F2937] dark:text-white">
//                 {editingIssue ? "Edit Issue" : "Add Issue"}
//               </h2>
//               <button
//                 onClick={() => {
//                   setShowIssueForm(false);
//                   setEditingIssue(null);
//                 }}
//                 className="text-[#6B7280] hover:text-[#EF4444] dark:text-gray-300 transition-colors"
//                 aria-label="Close modal"
//               >
//                 <XMarkIcon className="w-6 h-6" />
//               </button>
//             </div>
//             <div className="overflow-y-auto px-5 sm:px-6 md:px-8 py-4 bg-[#FAF8FF] dark:bg-gray-800 rounded-b-xl">
//               <IssuesForm
//                 editData={editingIssue}
//                 onIssueCreated={handleIssueCreated}
//                 onIssueUpdated={handleIssueUpdated}
//                 onClose={() => {
//                   setShowIssueForm(false);
//                   setEditingIssue(null);
//                 }}
//               />
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Response Modal */}
//       {isResponseModalOpen && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm ">
//           <div className="bg-white p-6 rounded-xl w-96 shadow-2xl relative dark:bg-gray-800 dark:text-white border border-[#E5E7EB] dark:border-gray-700">
//             <h2 className="text-xl font-bold cfg-heading text-[#1F2937] dark:text-white mb-4">
//               Add Response
//             </h2>
//             <textarea
//               name="content"
//               value={responseData.content}
//               onChange={handleInputChange}
//               placeholder="Type your response..."
//               className="w-full border border-[#E5E7EB] p-2 rounded-md mb-4 dark:bg-gray-700 dark:text-white dark:border-gray-600 focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] text-sm"
//               rows={4}
//             />
//             <div className="mb-4">
//               <input
//                 type="file"
//                 onChange={handleFileChange}
//                 className="w-full text-sm text-[#6B7280] file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-[#F3E8FF] file:text-[#673AB7] hover:file:bg-[#E9D5FF] transition"
//                 multiple
//               />
//             </div>
//             {/* Show selected files */}
//             {responseData.files.length > 0 && (
//               <div className="mb-4 bg-[#FAF8FF] dark:bg-gray-700 p-2 rounded border border-[#E5E7EB] dark:border-gray-600">
//                 <p className="text-sm font-semibold text-[#1F2937] dark:text-white mb-1">
//                   Selected files:
//                 </p>
//                 <ul className="text-xs text-[#374151] dark:text-gray-300 space-y-1">
//                   {responseData.files.map((file, index) => (
//                     <li key={index} className="flex items-center gap-1">
//                       📄 {file.name}
//                     </li>
//                   ))}
//                 </ul>
//               </div>
//             )}
//             <div className="flex justify-end gap-2 mt-2">
//               <button
//                 onClick={() => setIsResponseModalOpen(false)}
//                 className="bg-[#F3F4F6] text-[#374151] px-4 py-2 rounded-md hover:bg-[#E5E7EB] font-semibold text-sm transition"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={handleResponseSubmit}
//                 className="bg-[#673AB7] text-white px-4 py-2 rounded-md hover:bg-[#5E35A6] font-semibold text-sm transition"
//               >
//                 Submit
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* View Responses Modal */}
//       {isViewModalOpen && selectedIssue && (
//         <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex justify-center items-center z-50">
//           <div className="bg-white rounded-2xl w-full max-w-3xl p-6 shadow-2xl relative dark:bg-gray-800 dark:text-white border border-[#E5E7EB] dark:border-gray-700">
//             <h2 className="text-2xl font-bold cfg-heading text-[#673AB7] dark:text-[#E9D5FF] mb-6 border-b border-[#E5E7EB] dark:border-gray-700 pb-3">
//               {selectedIssue.title}
//             </h2>

//             <div className="space-y-5 max-h-[70vh] overflow-y-auto pr-2 scrollbar-thin scrollbar-thumb-[#E5E7EB] dark:scrollbar-thumb-gray-600">
//               {issueResponses.length === 0 ? (
//                 <div className="text-center py-8">
//                   <p className="text-[#6B7280] dark:text-gray-400 italic">
//                     No responses available.
//                   </p>
//                 </div>
//               ) : (
//                 issueResponses.map((res, idx) => (
//                   <div
//                     key={idx}
//                     className="bg-[#FAF8FF] border border-[#E5E7EB] rounded-lg p-4 shadow-sm dark:bg-gray-700 dark:border-gray-600"
//                   >
//                     <div className="flex justify-between items-start dark:text-white">
//                       <div className="pr-4">
//                         <p className="text-sm font-bold text-[#1F2937] dark:text-white">
//                           {res.userName}
//                         </p>
//                         <p className="text-sm text-[#374151] mt-2 dark:text-gray-200 whitespace-pre-wrap">
//                           {res.content}
//                         </p>
//                         <p className="text-xs text-[#6B7280] font-medium mt-3 dark:text-gray-400">
//                           Posted on: {new Date(res.createdAt).toLocaleString()}
//                         </p>
//                       </div>

//                       <div className="flex gap-2 items-center text-lg bg-white dark:bg-gray-800 p-1.5 rounded-md border border-[#E5E7EB] dark:border-gray-600 shadow-sm">
//                         <button
//                           onClick={() => toggleCommentBox(res.id)}
//                           title="Add Comment"
//                           className="text-[#8B5CF6] hover:text-[#673AB7] p-1.5 rounded hover:bg-[#F3E8FF] dark:hover:bg-gray-600 transition"
//                         >
//                           <FaCommentAlt className="w-4 h-4" />
//                         </button>

//                         {res.userId === user?.id && (
//                           <>
//                             <button
//                               title="Edit Response"
//                               onClick={() => handleEditResponse(res)}
//                               className="text-[#8B5CF6] hover:text-[#673AB7] p-1.5 rounded hover:bg-[#F3E8FF] dark:hover:bg-gray-600 transition"
//                             >
//                               <FaEdit className="w-4 h-4" />
//                             </button>
//                             <button
//                               title="Delete Response"
//                               onClick={() => handleDeleteResponse(res.id)}
//                               className="text-[#EF4444] hover:text-[#B91C1C] p-1.5 rounded hover:bg-[#FEF2F2] dark:hover:bg-gray-600 transition"
//                             >
//                               <FaTrash className="w-4 h-4" />
//                             </button>
//                           </>
//                         )}

//                         {res.attachment && res.attachment.length > 0 && (
//                           <>
//                             <button
//                               title="View Attachment"
//                               onClick={() =>
//                                 viewResponseAttachment(
//                                   selectedIssue.issueId,
//                                   res.id,
//                                   res.attachment[0]
//                                 )
//                               }
//                               className="text-green-600 hover:text-green-800 p-1.5 rounded hover:bg-green-50 dark:hover:bg-gray-600 transition"
//                             >
//                               <FaEye className="w-4 h-4" />
//                             </button>
//                             <button
//                               title="Download Attachment"
//                               onClick={() =>
//                                 downloadResponseAttachment(
//                                   selectedIssue.issueId,
//                                   res.id,
//                                   res.attachment[0]
//                                 )
//                               }
//                               className="text-[#6B7280] hover:text-[#374151] p-1.5 rounded hover:bg-[#F3F4F6] dark:hover:bg-gray-600 transition"
//                             >
//                               <FaDownload className="w-4 h-4" />
//                             </button>
//                           </>
//                         )}
//                       </div>
//                     </div>

//                     {/* Comments */}
//                     <div className="mt-4 space-y-3 pl-2 border-l-2 border-[#E5E7EB] dark:border-gray-600 ml-2">
//                       {res.comments?.map((comment) => (
//                         <div
//                           key={comment.commentId}
//                           className="bg-white dark:bg-gray-800 border border-[#E5E7EB] dark:border-gray-600 border-l-4 border-l-[#8B5CF6] p-3 rounded-md shadow-sm max-w-full"
//                         >
//                           <p className="text-sm break-words whitespace-pre-wrap text-[#374151] dark:text-gray-200">
//                             <span className="font-bold text-[#1F2937] dark:text-white">
//                               {comment.userName || "Unknown"}:
//                             </span>{" "}
//                             {comment.content || "No comment text"}
//                           </p>
//                           <div className="flex justify-between items-center mt-2">
//                             <p className="text-xs font-medium text-[#6B7280] dark:text-gray-400">
//                               {new Date(comment.createdAt).toLocaleString()}
//                             </p>

//                             {comment.userId === user?.id && (
//                               <div className="flex gap-3 flex-wrap">
//                                 <button
//                                   onClick={() =>
//                                     handleEditComment(res.id, comment)
//                                   }
//                                   className="text-[#8B5CF6] hover:text-[#673AB7] text-xs font-semibold flex items-center gap-1 transition"
//                                   title="Edit Comment"
//                                 >
//                                   <FaEdit /> <span>Edit</span>
//                                 </button>
//                                 <button
//                                   onClick={() =>
//                                     handleDeleteResponseComment(
//                                       res.id,
//                                       comment.commentId
//                                     )
//                                   }
//                                   className="text-[#EF4444] hover:text-[#B91C1C] text-xs font-semibold flex items-center gap-1 transition"
//                                   title="Delete Comment"
//                                 >
//                                   <FaTrash /> <span>Delete</span>
//                                 </button>
//                               </div>
//                             )}
//                           </div>
//                         </div>
//                       ))}
//                     </div>

//                     {/* Comment Input */}
//                     {showCommentBoxId === res.id && (
//                       <div className="mt-4 bg-white dark:bg-gray-800 p-3 rounded-lg border border-[#E5E7EB] dark:border-gray-600 shadow-sm">
//                         <textarea
//                           rows={2}
//                           className="w-full p-2 border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] text-sm dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//                           value={commentInput}
//                           onChange={(e) => {
//                             if (e.target.value.length <= 150) {
//                               setCommentInput(e.target.value);
//                             }
//                           }}
//                           placeholder="Write your comment..."
//                           maxLength={150}
//                         ></textarea>
//                         <div className="flex justify-between items-center mt-1">
//                           <span className="text-xs text-[#6B7280] dark:text-gray-400 font-medium">
//                             {commentInput.length}/150 characters
//                           </span>
//                           {commentInput.length > 150 && (
//                             <span className="text-xs text-[#EF4444] font-medium">
//                               comment must not exceed 150 characters
//                             </span>
//                           )}
//                         </div>
//                         <div className="flex justify-end mt-2 gap-2">
//                           <button
//                             onClick={() => toggleCommentBox(res.id)}
//                             className="px-3 py-1.5 text-sm font-semibold bg-[#F3F4F6] text-[#374151] hover:bg-[#E5E7EB] rounded-md transition dark:bg-gray-600 dark:text-gray-200 dark:hover:bg-gray-500"
//                           >
//                             Cancel
//                           </button>
//                           <button
//                             onClick={() => submitComment(res.id)}
//                             disabled={commentInput.length > 150}
//                             className={`px-4 py-1.5 bg-[#673AB7] text-white font-semibold rounded-md hover:bg-[#5E35A6] text-sm transition ${
//                               commentInput.length > 150
//                                 ? "opacity-50 cursor-not-allowed"
//                                 : ""
//                             }`}
//                           >
//                             {editingComment ? "Update" : "Comment"}
//                           </button>
//                         </div>
//                       </div>
//                     )}
//                   </div>
//                 ))
//               )}
//             </div>

//             <button
//               onClick={() => {
//                 setIsViewModalOpen(false);
//                 setShowCommentBoxId(null);
//                 setCommentInput("");
//                 setEditingComment(null);
//               }}
//               className="absolute top-4 right-4 text-[#6B7280] hover:text-[#EF4444] text-xl transition-colors bg-white dark:bg-gray-800 rounded-full p-1 shadow-sm border border-[#E5E7EB] dark:border-gray-600"
//             >
//               <FaTimes />
//             </button>
//           </div>
//         </div>
//       )}

//       {/* Response File Modal */}
//       {responseFileModalOpen && currentResponseFile && (
//         <div className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm flex items-center justify-center p-4">
//           <div className="relative bg-white rounded-xl shadow-2xl w-full max-w-4xl max-h-[90vh] flex flex-col dark:bg-gray-800 dark:text-white border border-[#E5E7EB] dark:border-gray-700">
//             <div className="flex justify-between items-center p-4 border-b border-[#E5E7EB] dark:border-gray-700 bg-[#FAF8FF] dark:bg-gray-800 rounded-t-xl">
//               <h3 className="text-lg font-bold cfg-heading text-[#1F2937] dark:text-white">
//                 {currentResponseFile.name}
//               </h3>
//               <button
//                 onClick={() => {
//                   setResponseFileModalOpen(false);
//                   URL.revokeObjectURL(currentResponseFile.url);
//                   setCurrentResponseFile(null);
//                 }}
//                 className="text-[#6B7280] hover:text-[#EF4444] dark:hover:text-red-400 transition"
//               >
//                 <FaTimes className="w-5 h-5" />
//               </button>
//             </div>

//             <div className="flex-1 overflow-auto p-4 flex items-center justify-center bg-gray-50 dark:bg-gray-900">
//               {currentResponseFile.type === "image" ? (
//                 <img
//                   src={currentResponseFile.url}
//                   alt="File preview"
//                   className="max-w-full max-h-[70vh] object-contain shadow-sm rounded border border-gray-200 dark:border-gray-700"
//                 />
//               ) : currentResponseFile.type === "pdf" ? (
//                 <iframe
//                   src={`${currentResponseFile.url}#toolbar=0`}
//                   className="w-full h-[70vh] border-none rounded shadow-sm"
//                   title="PDF preview"
//                 />
//               ) : currentResponseFile.type === "video" ? (
//                 <video
//                   controls
//                   className="w-full max-h-[70vh] rounded shadow-sm"
//                 >
//                   <source
//                     src={currentResponseFile.url}
//                     type={`video/${currentResponseFile.name.split(".").pop()}`}
//                   />
//                   Your browser does not support the video tag.
//                 </video>
//               ) : currentResponseFile.type === "audio" ? (
//                 <audio controls className="w-full max-w-md">
//                   <source
//                     src={currentResponseFile.url}
//                     type={`audio/${currentResponseFile.name.split(".").pop()}`}
//                   />
//                   Your browser does not support the audio element.
//                 </audio>
//               ) : currentResponseFile.type === "office" ? (
//                 <iframe
//                   src={getOfficeViewerUrl(currentResponseFile.url)}
//                   className="w-full h-[70vh] border-none rounded shadow-sm"
//                   title="Office document preview"
//                   allowFullScreen
//                 />
//               ) : currentResponseFile.type === "text" ? (
//                 <iframe
//                   src={currentResponseFile.url}
//                   className="w-full h-[70vh] border-none rounded bg-white dark:bg-gray-800 shadow-sm"
//                   title="Text preview"
//                 />
//               ) : (
//                 <div className="text-center p-8 bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700">
//                   <p className="text-[#6B7280] font-medium mb-4 dark:text-gray-300">
//                     Preview not available for this file type
//                   </p>
//                   <button
//                     onClick={() =>
//                       downloadResponseAttachment(
//                         selectedIssue.issueId,
//                         issueResponses.find(
//                           (r) =>
//                             r.attachment &&
//                             r.attachment.includes(currentResponseFile.name)
//                         )?.id,
//                         currentResponseFile.name
//                       )
//                     }
//                     className="px-5 py-2.5 bg-[#673AB7] text-white font-semibold rounded-md hover:bg-[#5E35A6] shadow-md transition"
//                   >
//                     Download File
//                   </button>
//                 </div>
//               )}
//             </div>

//             <div className="flex justify-end p-4 border-t border-[#E5E7EB] dark:border-gray-700 bg-white dark:bg-gray-800 rounded-b-xl">
//               <button
//                 onClick={() =>
//                   downloadResponseAttachment(
//                     selectedIssue.issueId,
//                     issueResponses.find(
//                       (r) =>
//                         r.attachment &&
//                         r.attachment.includes(currentResponseFile.name)
//                     )?.id,
//                     currentResponseFile.name
//                   )
//                 }
//                 className="px-5 py-2 bg-[#673AB7] text-white font-semibold rounded-md hover:bg-[#5E35A6] transition flex items-center gap-2"
//               >
//                 <FaDownload /> Download
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Delete Confirmation Modal */}
//       {showDeleteModal && issueToDelete && (
//         <div className="fixed inset-0 flex items-center justify-center bg-black/50 backdrop-blur-sm z-50">
//           <div className="bg-white rounded-xl p-6 shadow-2xl w-full max-w-sm dark:bg-gray-800 dark:text-white border border-[#E5E7EB] dark:border-gray-700 transform transition-all scale-100">
//             <h2 className="text-xl font-bold text-[#1F2937] mb-3 cfg-heading dark:text-white">
//               Confirm Delete
//             </h2>
//             <p className="text-[#374151] mb-6 dark:text-gray-300 text-sm">
//               Are you sure you want to delete this issue? This action cannot be
//               undone.
//             </p>
//             <div className="flex justify-end space-x-3">
//               <button
//                 className="px-4 py-2 font-semibold text-[#374151] bg-[#F3F4F6] border border-[#E5E7EB] rounded-md hover:bg-[#E5E7EB] transition dark:bg-gray-700 dark:text-gray-200 dark:border-gray-600 dark:hover:bg-gray-600"
//                 onClick={() => setShowDeleteModal(false)}
//               >
//                 Cancel
//               </button>
//               <button
//                 className="px-4 py-2 font-semibold bg-[#EF4444] text-white rounded-md hover:bg-[#B91C1C] shadow-md transition"
//                 onClick={() => handleDeleteIssue(issueToDelete.issueId)}
//               >
//                 Delete
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Attachment View Modal */}
//       {showAttachmentModal && currentAttachment && (
//         <div className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-center justify-center p-4">
//           <div className="relative bg-white rounded-xl shadow-2xl w-full max-w-5xl max-h-[90vh] flex flex-col dark:bg-gray-800 dark:text-white border border-[#E5E7EB] dark:border-gray-700">
//             <div className="flex justify-between items-center p-4 border-b border-[#E5E7EB] dark:border-gray-700 bg-[#FAF8FF] dark:bg-gray-800 rounded-t-xl">
//               <h3 className="text-lg font-bold cfg-heading truncate max-w-[80%] text-[#1F2937] dark:text-white">
//                 {currentAttachment.name}{" "}
//                 <span className="text-sm font-medium text-[#673AB7] dark:text-[#E9D5FF] ml-2 bg-[#F3E8FF] dark:bg-purple-900 px-2 py-0.5 rounded-full">
//                   ({currentAttachment.index + 1}/{currentAttachment.total})
//                 </span>
//               </h3>
//               <button
//                 onClick={() => {
//                   setShowAttachmentModal(false);
//                   URL.revokeObjectURL(currentAttachment.url);
//                   setCurrentAttachment(null);
//                 }}
//                 className="text-[#6B7280] hover:text-[#EF4444] dark:hover:text-red-400 p-1 transition"
//               >
//                 <FaTimes className="w-5 h-5" />
//               </button>
//             </div>

//             <div className="flex-1 overflow-auto p-4 flex items-center justify-center relative bg-gray-50 dark:bg-gray-900 min-h-[50vh]">
//               {/* Navigation arrows */}
//               {currentAttachment.total > 1 && (
//                 <>
//                   {currentAttachment.index > 0 && (
//                     <button
//                       onClick={() => {
//                         URL.revokeObjectURL(currentAttachment.url);
//                         const newIndex = currentAttachment.index - 1;
//                         handleViewAttachment(selectedIssue, newIndex);
//                       }}
//                       className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white/80 dark:bg-black/50 text-[#673AB7] dark:text-white p-2.5 rounded-full hover:bg-white dark:hover:bg-black/70 hover:scale-110 shadow-lg border border-[#E5E7EB] dark:border-gray-600 transition z-10"
//                     >
//                       <FaChevronLeft className="w-5 h-5" />
//                     </button>
//                   )}
//                   {currentAttachment.index < currentAttachment.total - 1 && (
//                     <button
//                       onClick={() => {
//                         URL.revokeObjectURL(currentAttachment.url);
//                         const newIndex = currentAttachment.index + 1;
//                         handleViewAttachment(selectedIssue, newIndex);
//                       }}
//                       className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white/80 dark:bg-black/50 text-[#673AB7] dark:text-white p-2.5 rounded-full hover:bg-white dark:hover:bg-black/70 hover:scale-110 shadow-lg border border-[#E5E7EB] dark:border-gray-600 transition z-10"
//                     >
//                       <FaChevronRight className="w-5 h-5" />
//                     </button>
//                   )}
//                 </>
//               )}

//               {/* File preview */}
//               {currentAttachment.type === "image" ? (
//                 <img
//                   src={currentAttachment.url}
//                   alt="Attachment preview"
//                   className="max-h-full max-w-full object-contain shadow-sm rounded"
//                 />
//               ) : currentAttachment.type === "video" ? (
//                 <video
//                   controls
//                   className="w-full h-full max-h-[70vh] rounded shadow-sm"
//                 >
//                   <source
//                     src={currentAttachment.url}
//                     type={`video/${currentAttachment.name.split(".").pop()}`}
//                   />
//                   Your browser does not support the video tag.
//                 </video>
//               ) : currentAttachment.type === "audio" ? (
//                 <audio
//                   controls
//                   className="w-full max-w-md shadow-sm rounded-full"
//                 >
//                   <source
//                     src={currentAttachment.url}
//                     type={`audio/${currentAttachment.name.split(".").pop()}`}
//                   />
//                   Your browser does not support the audio element.
//                 </audio>
//               ) : currentAttachment.type === "pdf" ? (
//                 <iframe
//                   src={`${currentAttachment.url}#toolbar=0`}
//                   className="w-full h-full min-h-[60vh] border-none rounded shadow-sm bg-white"
//                   title="PDF preview"
//                 />
//               ) : ["word", "excel", "powerpoint"].includes(
//                   currentAttachment.type
//                 ) ? (
//                 <iframe
//                   src={getOfficeViewerUrl(currentAttachment.url)}
//                   className="w-full h-full min-h-[60vh] border-none rounded shadow-sm bg-white"
//                   title={`${currentAttachment.type} document preview`}
//                   allowFullScreen
//                 />
//               ) : currentAttachment.type === "text" ? (
//                 <iframe
//                   src={currentAttachment.url}
//                   className="w-full h-full min-h-[60vh] border border-[#E5E7EB] dark:border-gray-700 rounded shadow-sm bg-white dark:bg-gray-800"
//                   title="Text preview"
//                 />
//               ) : (
//                 <div className="flex flex-col items-center justify-center h-full p-8 bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700">
//                   <FaEye className="w-12 h-12 text-[#E5E7EB] dark:text-gray-600 mb-4" />
//                   <p className="text-[#6B7280] font-medium text-center dark:text-gray-300">
//                     Preview not available for this file type
//                   </p>
//                 </div>
//               )}
//             </div>

//             <div className="mt-auto flex flex-col sm:flex-row justify-between items-center p-4 border-t border-[#E5E7EB] dark:border-gray-700 bg-white dark:bg-gray-800 rounded-b-xl gap-4">
//               <div className="flex space-x-2 overflow-x-auto max-w-full pb-2 sm:pb-0 scrollbar-thin">
//                 {selectedIssue.attachments.map((file, idx) => (
//                   <button
//                     key={idx}
//                     onClick={() => {
//                       URL.revokeObjectURL(currentAttachment.url);
//                       handleViewAttachment(selectedIssue, idx);
//                     }}
//                     className={`w-12 h-12 flex-shrink-0 flex items-center justify-center rounded-lg border-2 transition-all ${
//                       idx === currentAttachment.index
//                         ? "border-[#673AB7] bg-[#F3E8FF] dark:bg-purple-900/40 shadow-sm scale-105"
//                         : "border-[#E5E7EB] hover:border-[#8B5CF6] hover:bg-[#FAF8FF] dark:border-gray-600 dark:hover:border-purple-500 dark:hover:bg-gray-700"
//                     }`}
//                     title={file}
//                   >
//                     {file.split(".").pop().toLowerCase() === "pdf" ? (
//                       <span className="text-[#EF4444] font-bold text-xs">
//                         PDF
//                       </span>
//                     ) : ["jpg", "jpeg", "png", "gif"].includes(
//                         file.split(".").pop().toLowerCase()
//                       ) ? (
//                       <span className="text-[#10B981] font-bold text-xs">
//                         IMG
//                       </span>
//                     ) : (
//                       <span className="text-[#6B7280] dark:text-gray-300 font-bold text-xs truncate max-w-[40px]">
//                         {file.split(".").pop().toUpperCase().substring(0, 3)}
//                       </span>
//                     )}
//                   </button>
//                 ))}
//               </div>
//               <button
//                 onClick={() =>
//                   handleDownloadAttachment(selectedIssue, currentAttachment.name)
//                 }
//                 className="px-5 py-2.5 w-full sm:w-auto bg-[#673AB7] text-white font-semibold rounded-md hover:bg-[#5E35A6] shadow-md transition flex items-center justify-center gap-2"
//               >
//                 <FaDownload /> Download
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Status Update Modal */}
//       {statusUpdateModalOpen && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
//           <div className="bg-white p-6 rounded-xl shadow-2xl w-full max-w-sm dark:bg-gray-800 dark:text-white border border-[#E5E7EB] dark:border-gray-700">
//             <h2 className="text-xl font-bold mb-5 cfg-heading text-[#1F2937] dark:text-white">
//               Update Issue Status
//             </h2>

//             <div className="mb-4">
//               <label className="block text-[#374151] font-semibold text-sm mb-2 dark:text-gray-200">
//                 New Status:
//               </label>
//               <div className="p-2.5 bg-[#FAF8FF] text-[#673AB7] font-bold rounded-md border border-[#E9D5FF] dark:bg-purple-900/30 dark:border-purple-700 dark:text-purple-300">
//                 {selectedStatusUpdate.newStatus}
//               </div>
//             </div>

//             <div className="mb-5">
//               <label className="block text-[#374151] font-semibold text-sm mb-2 dark:text-gray-200">
//                 Remark:
//               </label>
//               <textarea
//                 className="w-full p-3 border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] text-sm dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//                 rows="4"
//                 placeholder="Enter remark for status change..."
//                 value={selectedStatusUpdate.remark}
//                 onChange={(e) =>
//                   setSelectedStatusUpdate((prev) => ({
//                     ...prev,
//                     remark: e.target.value,
//                   }))
//                 }
//               />
//             </div>

//             <div className="flex justify-end space-x-3">
//               <button
//                 className="px-4 py-2 font-semibold bg-[#F3F4F6] text-[#374151] border border-[#E5E7EB] rounded-md hover:bg-[#E5E7EB] transition dark:bg-gray-700 dark:text-gray-200 dark:border-gray-600 dark:hover:bg-gray-600"
//                 onClick={() => setStatusUpdateModalOpen(false)}
//               >
//                 Cancel
//               </button>
//               <button
//                 className="px-4 py-2 font-semibold bg-[#673AB7] text-white rounded-md hover:bg-[#5E35A6] shadow-md transition"
//                 onClick={handleStatusUpdateSubmit}
//               >
//                 Update Status
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Edit Response Modal */}
//       {editModalData && (
//         <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex justify-center items-center z-50 p-4">
//           <div className="bg-white rounded-xl w-full max-w-xl p-6 shadow-2xl relative dark:bg-gray-800 dark:text-white border border-[#E5E7EB] dark:border-gray-700">
//             <h2 className="text-xl font-bold cfg-heading text-[#673AB7] dark:text-[#E9D5FF] mb-5 border-b border-[#E5E7EB] dark:border-gray-700 pb-3">
//               Edit Response
//             </h2>

//             <label className="block mb-4 text-[#374151] font-semibold text-sm dark:text-gray-200">
//               Content
//               <textarea
//                 value={updatedContent}
//                 onChange={(e) => setUpdatedContent(e.target.value)}
//                 rows={4}
//                 className="w-full p-3 mt-1.5 border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] font-normal text-sm dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//               />
//             </label>

//             <label className="block mb-6 text-[#374151] font-semibold text-sm dark:text-gray-200">
//               Upload New File{" "}
//               <span className="text-[#6B7280] font-normal italic">
//                 (optional)
//               </span>
//               <input
//                 type="file"
//                 onChange={(e) => setUpdatedFile(e.target.files[0])}
//                 className="w-full mt-1.5 text-sm text-[#6B7280] file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-[#F3E8FF] file:text-[#673AB7] hover:file:bg-[#E9D5FF] transition dark:bg-gray-700 dark:text-white"
//               />
//             </label>

//             <div className="flex justify-end gap-3 mt-4">
//               <button
//                 className="px-5 py-2 font-semibold bg-[#F3F4F6] text-[#374151] border border-[#E5E7EB] rounded-md hover:bg-[#E5E7EB] transition dark:bg-gray-700 dark:text-gray-200 dark:border-gray-600 dark:hover:bg-gray-600"
//                 onClick={() => setEditModalData(null)}
//               >
//                 Cancel
//               </button>

//               <button
//                 className="px-5 py-2 font-semibold bg-[#673AB7] text-white rounded-md hover:bg-[#5E35A6] shadow-md transition"
//                 onClick={handleUpdateResponse}
//               >
//                 Update
//               </button>
//             </div>

//             <button
//               onClick={() => setEditModalData(null)}
//               className="absolute top-4 right-4 text-[#6B7280] hover:text-[#EF4444] transition-colors bg-white dark:bg-gray-800 rounded-full p-1 border border-transparent hover:border-[#EF4444] hover:bg-[#FEF2F2] dark:hover:bg-gray-700"
//             >
//               <FaTimes className="w-5 h-5" />
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }














import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import axios from "axios";
import {
  FaEdit,
  FaTrash,
  FaChevronDown,
  FaChevronUp,
  FaEye,
  FaPlusCircle,
  FaReply,
  FaCommentDots,
  FaSearch,
  FaTimes,
  FaTicketAlt,
  FaDownload,
  FaCommentAlt,
  FaList,
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa";
import { XMarkIcon } from "@heroicons/react/24/solid";
import Select from "react-select";
import { AuthContext } from "../context/AuthContext";
import { API_URL } from "../../Constants";
import { toast } from "react-toastify";
import { PlusIcon } from "lucide-react";
import IssuesForm from "./IssuesForm";

const EMPTY_SEARCH = {
  subject: "",
  priority: "",
  targetUserId: "",
  startDate: "",
  endDate: "",
};

export default function Issues({ refreshTrigger }) {
  const { user } = useContext(AuthContext);
  const [issues, setIssues] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [users, setUsers] = useState([]);
  const [expandedIssue, setExpandedIssue] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isTicketModalOpen, setIsTicketModalOpen] = useState(false);
  const [selectedIssue, setSelectedIssue] = useState(null);
  const [comments, setComments] = useState([]);
  const [ticketDetails, setTicketDetails] = useState(null);
  const [isCommentBoxOpen, setIsCommentBoxOpen] = useState(false);
  const [newComment, setNewComment] = useState("");
  const [isResponseModalOpen, setIsResponseModalOpen] = useState(false);
  const [responseData, setResponseData] = useState({ content: "", files: [] });
  const [issueResponses, setIssueResponses] = useState([]);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [issueToDelete, setIssueToDelete] = useState(null);
  const [searchParams, setSearchParams] = useState(EMPTY_SEARCH);
  // null = normal listing, object = the search that was actually submitted
  const [appliedSearch, setAppliedSearch] = useState(null);
  const isSearching = appliedSearch !== null;
  const [showFields, setShowFields] = useState(false);
  const [showAttachmentModal, setShowAttachmentModal] = useState(false);
  const [currentAttachment, setCurrentAttachment] = useState(null);
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const abortRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [editModalData, setEditModalData] = useState(null); // response to edit
  const [updatedContent, setUpdatedContent] = useState("");
  const [updatedFile, setUpdatedFile] = useState(null);
  const [currentResponseFile, setCurrentResponseFile] = useState(null);
  const [responseFileModalOpen, setResponseFileModalOpen] = useState(false);
  const [remarkInput, setRemarkInput] = useState("");
  const [actionType, setActionType] = useState(""); // "APPROVED" or "REJECTED"
  const [showRemarkInput, setShowRemarkInput] = useState(false);
  const [editingCommentId, setEditingCommentId] = useState(null);
  const [editedComment, setEditedComment] = useState("");
  const [showCommentBoxId, setShowCommentBoxId] = useState(null);
  const [commentInput, setCommentInput] = useState("");
  const [editingComment, setEditingComment] = useState(null);
  const [statusUpdateModalOpen, setStatusUpdateModalOpen] = useState(false);
  const [commentLengthError, setCommentLengthError] = useState("");
  const [selectedStatusUpdate, setSelectedStatusUpdate] = useState({
    issueId: null,
    newStatus: "",
    remark: "",
  });
  const [showIssueForm, setShowIssueForm] = useState(false);
  const [editingIssue, setEditingIssue] = useState(null);

  const getToken = () => localStorage.getItem("token");

  // ---------------------------------------------------------------------
  // Data loading (single source of truth for fetching issues)
  // ---------------------------------------------------------------------
  const fetchPage = useCallback(
    async (page = 0) => {
      if (!user?.id) return;

      const token = getToken();
      if (!token) {
        toast.error("Authentication token missing", {
          toastId: "auth-missing",
        });
        return;
      }

      // cancel any in-flight request
      abortRef.current?.abort();
      const controller = new AbortController();
      abortRef.current = controller;
      setIsLoading(true);

      try {
        const companyId =
          user.accountType === "COMPANY" ? user.id : user.companyId;
        const headers = { Authorization: `Bearer ${token}` };
        let response;

        if (appliedSearch) {
          const params = Object.fromEntries(
            Object.entries(appliedSearch).filter(([, v]) => v !== "")
          );
          response = await axios.get(
            `${API_URL}/api/issues/search/${companyId}/${user.id}`,
            {
              params: { ...params, pageNumber: page, pageSize },
              headers,
              signal: controller.signal,
            }
          );
        } else {
          const endpoint =
            user.accountType === "COMPANY"
              ? `${API_URL}/api/issues/company/${user.id}`
              : `${API_URL}/api/issues/forUser/${user.id}`;

          response = await axios.get(endpoint, {
            params: { pageNumber: page, pageSize },
            headers,
            signal: controller.signal,
          });
        }

        setIssues(
          Array.isArray(response.data?.issues) ? response.data.issues : []
        );
        setTotalPages(response.data?.totalPages || 0);
        setPageNumber(page);
      } catch (err) {
        if (axios.isCancel(err)) return; // ignore cancelled requests
        console.error("Error fetching issues:", err);
        setIssues([]);
        setTotalPages(0);
        toast.error(err.response?.data?.message || "Failed to load issues", {
          toastId: "issues-load-error",
        });
      } finally {
        if (abortRef.current === controller) setIsLoading(false);
      }
    },
    [user?.id, user?.accountType, user?.companyId, pageSize, appliedSearch]
  );

  // The ONLY effect that loads the list. Re-runs when page size, search,
  // user or refreshTrigger change.
  useEffect(() => {
    fetchPage(0);
    return () => abortRef.current?.abort();
  }, [fetchPage, refreshTrigger]);

  // Fetch Statuses
  useEffect(() => {
    async function fetchStatuses() {
      const companyId =
        user?.accountType === "COMPANY" ? user.id : user?.companyId;
      if (!companyId) return;

      try {
        const statusResponse = await axios.get(
          `${API_URL}/api/issueStatus/company/${companyId}`,
          { headers: { authorization: `Bearer ${getToken()}` } }
        );
        setStatuses(statusResponse.data);
      } catch (error) {
        console.error("Error fetching statuses:", error);
      }
    }
    fetchStatuses();
  }, [user]);

  // Fetch Users
  useEffect(() => {
    async function fetchUsers() {
      if (!user?.id || !user?.accountType) return;
      const url =
        user?.accountType === "COMPANY"
          ? `${API_URL}/api/companyuser/getByUserId?userId=${user.id}&accountType=${user.accountType}`
          : `${API_URL}/api/companyuser/getSameAndSubordinateUsers?userId=${user.id}&accountType=${user.accountType}`;

      try {
        const response = await axios.get(url, {
          headers: { authorization: `Bearer ${getToken()}` },
        });
        setUsers(response.data);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    }
    fetchUsers();
  }, [user]);

  // ---------------------------------------------------------------------
  // Form callbacks
  // ---------------------------------------------------------------------
  const handleEditClick = (issue) => {
    setEditingIssue(issue);
    setShowIssueForm(true);
  };

  const handleIssueCreated = useCallback(() => {
    setShowIssueForm(false);
    setEditingIssue(null);
    fetchPage(0);
  }, [fetchPage]);

  const handleIssueUpdated = useCallback(() => {
    setShowIssueForm(false);
    setEditingIssue(null);
    fetchPage(pageNumber);
  }, [fetchPage, pageNumber]);

  const handleKeyDown = useCallback((event) => {
    if (
      event.key === "Escape" ||
      (event.altKey && event.key.toLowerCase() === "c")
    ) {
      setShowIssueForm(false);
      setEditingIssue(null);
    }
  }, []);

  useEffect(() => {
    if (showIssueForm) {
      document.addEventListener("keydown", handleKeyDown);
    }
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [showIssueForm, handleKeyDown]);

  // ---------------------------------------------------------------------
  // Status change
  // ---------------------------------------------------------------------
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setResponseData((prev) => ({ ...prev, [name]: value }));
  };

  const handleStatusChange = (issueId, newStatus, e) => {
    e.stopPropagation();
    setSelectedStatusUpdate({ issueId, newStatus, remark: "" });
    setStatusUpdateModalOpen(true);
  };

  const handleStatusUpdateSubmit = async () => {
    if (!selectedStatusUpdate.remark.trim()) {
      toast.error("Please enter a remark", { toastId: "status-remark" });
      return;
    }

    try {
      const response = await axios.put(
        `${API_URL}/api/issues/updateStatus/${selectedStatusUpdate.issueId}`,
        {
          newStatus: selectedStatusUpdate.newStatus,
          remark: selectedStatusUpdate.remark,
          updatedById: user.id,
          updatedByName: user.name,
        },
        {
          headers: {
            Authorization: `Bearer ${getToken()}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.status === "Successful") {
        toast.success(response.data.message, { toastId: "status-success" });
        setStatusUpdateModalOpen(false);
        fetchPage(pageNumber);
      } else {
        toast.error(response.data.message || "Failed to update status", {
          toastId: "status-update-error",
        });
      }
    } catch (error) {
      console.error("Error updating issue status:", error);
      toast.error(
        error.response?.data?.message || "Failed to update status",
        { toastId: "status-update-error" }
      );
    }
  };

  // ---------------------------------------------------------------------
  // Search
  // ---------------------------------------------------------------------
  const handleSearchChange = (e) => {
    const { name, value } = e.target;
    setSearchParams((prev) => ({ ...prev, [name]: value }));
  };

  // Just applies the filters; the loader effect does the fetch.
  const handleSearchSubmit = (e) => {
    e.preventDefault();
    setAppliedSearch({ ...searchParams });
  };

  const handleClearSearch = () => {
    setSearchParams(EMPTY_SEARCH);
    setAppliedSearch(null);
  };

  // ---------------------------------------------------------------------
  // Issue / ticket helpers
  // ---------------------------------------------------------------------
  const toggleDropdown = (issueId) => {
    setExpandedIssue(expandedIssue === issueId ? null : issueId);
  };

  const handleViewIssue = (issue) => {
    setSelectedIssue(issue);
    setIsModalOpen(true);
  };

  const loadTicket = async (issueId) => {
    const response = await axios.get(
      `${API_URL}/api/tickets/by-reference/${issueId}?referenceType=Issue`,
      { headers: { Authorization: `Bearer ${getToken()}` } }
    );
    setTicketDetails(response.data);
    setComments(response.data.comments || []);
    return response.data;
  };

  const handleViewTicket = async (issue) => {
    setSelectedIssue(issue);
    setIsTicketModalOpen(true);

    try {
      await loadTicket(issue.issueId);
    } catch (error) {
      console.error("Error fetching ticket details:", error);
      toast.error("Failed to load ticket details", {
        toastId: "ticket-load-error",
      });
    }
  };

  const handleAddComment = async () => {
    if (!newComment.trim()) return;
    if (newComment.trim().length > 150) {
      setCommentLengthError("comment must not exceed 150 characters");
      return;
    }
    if (!ticketDetails?.ticketId) {
      toast.error("Ticket not loaded yet", { toastId: "ticket-missing" });
      return;
    }

    try {
      await axios.post(
        `${API_URL}/api/tickets/addComment/${ticketDetails.ticketId}`,
        {
          userId: user.id,
          userName: user.name,
          content: newComment,
        },
        { headers: { Authorization: `Bearer ${getToken()}` } }
      );

      // reload the ticket so comments carry their real ids
      await loadTicket(selectedIssue.issueId);

      setNewComment("");
      setCommentLengthError("");
      setIsCommentBoxOpen(false);
    } catch (error) {
      console.error("Failed to post comment:", error);
      toast.error("Failed to post comment", { toastId: "comment-error" });
    }
  };

  // ---------------------------------------------------------------------
  // Responses
  // ---------------------------------------------------------------------
  const handleResponseClick = (issue) => {
    setSelectedIssue(issue);
    setIsResponseModalOpen(true);
  };

  const handleFileChange = (e) => {
    setResponseData((prev) => ({ ...prev, files: Array.from(e.target.files) }));
  };

  const handleViewResponse = async (clickedIssueId) => {
    try {
      const endpoint =
        user.accountType === "COMPANY"
          ? `${API_URL}/api/issues/company/${user.id}`
          : `${API_URL}/api/issues/forUser/${user.id}`;

      const response = await axios.get(endpoint, {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          "Content-Type": "application/json",
        },
      });

      const allIssues = Array.isArray(response.data.issues)
        ? response.data.issues
        : [];

      const foundIssue = allIssues.find(
        (issue) => issue.issueId === clickedIssueId
      );
      if (!foundIssue) return;

      setSelectedIssue(foundIssue);
      setIssueResponses(foundIssue.issueResponse || []);
      setIsViewModalOpen(true);
    } catch (error) {
      console.error("Error in handleViewResponse:", error);
      toast.error("Failed to load responses", {
        toastId: "responses-load-error",
      });
    }
  };

  const handleResponseSubmit = async () => {
    if (!selectedIssue) {
      toast.error("No Issue selected.", { toastId: "no-issue" });
      return;
    }

    const formData = new FormData();
    formData.append("content", responseData.content);
    formData.append("userId", user?.id);
    formData.append("userName", user?.name);
    responseData.files.forEach((file) => formData.append("files", file));

    try {
      const res = await fetch(
        `${API_URL}/api/issues/addResponse/${selectedIssue?.issueId}`,
        {
          method: "POST",
          body: formData,
          headers: { Authorization: `Bearer ${getToken()}` },
        }
      );

      const resJson = await res.json();

      if (res.ok) {
        toast.success(resJson.message, { toastId: "response-success" });
        setIsResponseModalOpen(false);
        setResponseData({ content: "", files: [] });
        handleViewResponse(selectedIssue.issueId);
      } else {
        toast.error(resJson?.message || "Failed to submit response.", {
          toastId: "response-error",
        });
      }
    } catch (err) {
      console.error("Error submitting response:", err);
      toast.error("Something went wrong while submitting response.", {
        toastId: "response-error",
      });
    }
  };

  const handleDeleteResponse = async (responseId) => {
    try {
      await axios.delete(
        `${API_URL}/api/issues/deleteResponse/${selectedIssue.issueId}/${responseId}`,
        { headers: { Authorization: `Bearer ${getToken()}` } }
      );
      toast.success("Response deleted", { toastId: "response-deleted" });
      handleViewResponse(selectedIssue.issueId);
    } catch (error) {
      console.error("Error deleting response:", error);
      toast.error(
        error.response?.data?.message || "Failed to delete response",
        { toastId: "response-delete-error" }
      );
    }
  };

  const handleEditResponse = (res) => {
    setEditModalData(res);
    setUpdatedContent(res.content);
    setUpdatedFile(null);
  };

  const handleUpdateResponse = async () => {
    const formData = new FormData();
    if (updatedFile) formData.append("files", updatedFile);

    formData.append("issueId", selectedIssue.issueId);
    formData.append("userId", user.id);
    formData.append("userName", user.name);
    formData.append("content", updatedContent);

    try {
      await axios.put(
        `${API_URL}/api/issues/updateResponse/${editModalData.id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      setEditModalData(null);
      setUpdatedContent("");
      setUpdatedFile(null);
      toast.success("Response updated", { toastId: "response-updated" });
      handleViewResponse(selectedIssue.issueId);
    } catch (err) {
      console.error("Error updating response:", err);
      toast.error(err.response?.data?.message || "Failed to update response", {
        toastId: "response-update-error",
      });
    }
  };

  // ---------------------------------------------------------------------
  // Delete issue
  // ---------------------------------------------------------------------
  const handleDeleteIssue = async (issueId) => {
    try {
      await axios.delete(`${API_URL}/api/issues/deleteIssue/${issueId}`, {
        headers: { Authorization: `Bearer ${getToken()}` },
      });

      toast.success("Issue deleted successfully", { toastId: "issue-deleted" });
      setShowDeleteModal(false);
      setIssueToDelete(null);
      fetchPage(0);
    } catch (error) {
      console.error("Delete failed:", error);
      toast.error(error.response?.data?.message || "Failed to delete issue", {
        toastId: "issue-delete-error",
      });
    }
  };

  // ---------------------------------------------------------------------
  // Attachments
  // ---------------------------------------------------------------------
  const getTypeCategory = (fileExtension, officeType) => {
    if (["jpg", "jpeg", "png", "gif", "webp"].includes(fileExtension))
      return "image";
    if (["mp4", "webm", "ogg"].includes(fileExtension)) return "video";
    if (["mp3", "wav"].includes(fileExtension)) return "audio";
    if (fileExtension === "pdf") return "pdf";
    if (["doc", "docx", "xls", "xlsx", "ppt", "pptx"].includes(fileExtension))
      return officeType;
    if (["txt", "csv"].includes(fileExtension)) return "text";
    return "other";
  };

  const handleViewAttachment = async (issue, index = 0) => {
    try {
      if (!issue.attachments || issue.attachments.length === 0) {
        toast.error("No attachments found", { toastId: "no-attachments" });
        return;
      }

      const fileName = issue.attachments[index];
      const fileExtension = fileName.split(".").pop().toLowerCase();
      const typeCategory = getTypeCategory(fileExtension, "unsupported");

      if (typeCategory === "unsupported") {
        toast.error("Preview not available for this file type", {
          toastId: "preview-unsupported",
        });
        return;
      }

      const response = await axios.get(
        `${API_URL}/api/issues/view/${issue.issueId}/${fileName}`,
        {
          responseType: "blob",
          headers: { Authorization: `Bearer ${getToken()}` },
        }
      );

      const blobType =
        typeCategory === "pdf" ? "application/pdf" : response.data.type;
      const blob = new Blob([response.data], { type: blobType });
      const fileUrl = URL.createObjectURL(blob);

      // PDF on mobile opens in a new tab instead of the modal
      const isMobile = window.innerWidth < 768;
      if (typeCategory === "pdf" && isMobile) {
        window.open(fileUrl, "_blank");
        return;
      }

      setCurrentAttachment({
        url: fileUrl,
        type: typeCategory,
        name: fileName,
        index,
        total: issue.attachments.length,
      });
      setShowAttachmentModal(true);
    } catch (error) {
      toast.error("Failed to view attachment", { toastId: "view-attach-error" });
      console.error(error);
    }
  };

  const handleDownloadAttachment = async (issue, fileName) => {
    try {
      if (!issue.attachments || issue.attachments.length === 0) {
        toast.error("No attachment found", { toastId: "no-attachments" });
        return;
      }

      const response = await axios.get(
        `${API_URL}/api/issues/download/${issue.issueId}/${fileName}`,
        {
          responseType: "blob",
          headers: { Authorization: `Bearer ${getToken()}` },
        }
      );

      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      toast.error("Failed to download attachment", {
        toastId: "download-attach-error",
      });
      console.error(error);
    }
  };

  const getOfficeViewerUrl = (fileUrl) => {
    return `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
      fileUrl
    )}`;
  };

  const viewResponseAttachment = async (issueId, responseId, fileName) => {
    try {
      const fileExtension = fileName.split(".").pop().toLowerCase();
      const typeCategory = getTypeCategory(fileExtension, "office");

      const response = await axios.get(
        `${API_URL}/api/issues/viewResponseAttachment/${issueId}/${responseId}/${fileName}`,
        {
          responseType: "blob",
          headers: { Authorization: `Bearer ${getToken()}` },
        }
      );

      const blobType =
        typeCategory === "pdf" ? "application/pdf" : response.data.type;
      const blob = new Blob([response.data], { type: blobType });
      const fileUrl = URL.createObjectURL(blob);

      const isMobile = window.innerWidth < 768;
      if (typeCategory === "pdf" && isMobile) {
        window.open(fileUrl, "_blank");
        return;
      }

      setCurrentResponseFile({
        url: fileUrl,
        type: typeCategory,
        name: fileName,
      });
      setResponseFileModalOpen(true);
    } catch (error) {
      console.error("Error viewing response attachment:", error);
      toast.error(
        "Failed to view attachment. You can try downloading it instead.",
        { toastId: "view-response-attach-error" }
      );
    }
  };

  const downloadResponseAttachment = async (issueId, responseId, fileName) => {
    try {
      const response = await axios.get(
        `${API_URL}/api/issues/downloadResponseAttachment/${issueId}/${responseId}/${fileName}`,
        {
          responseType: "blob",
          headers: { Authorization: `Bearer ${getToken()}` },
        }
      );

      const contentDisposition = response.headers["content-disposition"];
      let filename = fileName;
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1];
        }
      }

      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading response attachment:", error);
      toast.error("Failed to download attachment", {
        toastId: "download-response-attach-error",
      });
    }
  };

  // ---------------------------------------------------------------------
  // Approve / reject
  // ---------------------------------------------------------------------
  const handleApproveOrReject = async (issueId, newStatus, remark) => {
    try {
      const response = await fetch(
        `${API_URL}/api/issues/approveOrReject/${issueId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getToken()}`,
          },
          body: JSON.stringify({
            newStatus,
            updatedById: user?.id,
            updatedByName: user?.name,
            remark,
          }),
        }
      );

      if (response.ok) {
        await response.json();
        setSelectedIssue((prev) => ({ ...prev, statusName: newStatus }));
        setRemarkInput("");
        setShowRemarkInput(false);
        toast.success(`Issue ${newStatus.toLowerCase()}`, {
          toastId: "approve-reject-success",
        });
        fetchPage(pageNumber);
      } else {
        toast.error("Failed to update issue status", {
          toastId: "approve-reject-error",
        });
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Failed to update issue status", {
        toastId: "approve-reject-error",
      });
    }
  };

  // ---------------------------------------------------------------------
  // Ticket comments
  // ---------------------------------------------------------------------
  const handleUpdateComment = async (ticketId, commentId, content) => {
    try {
      const response = await axios.put(
        `${API_URL}/api/tickets/updateComment/${ticketId}/${commentId}`,
        content,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`,
            "Content-Type": "text/plain",
          },
        }
      );

      setEditingCommentId(null);
      setEditedComment("");

      const ticketData = response.data;
      setTicketDetails(ticketData);
      setComments(ticketData.comments || []);

      toast.success("Comment updated successfully", {
        toastId: "comment-updated",
      });
    } catch (error) {
      console.error("Error updating comment:", error);
      toast.error("Failed to update comment", {
        toastId: "comment-update-error",
      });
    }
  };

  const handleDeleteComment = async (commentId) => {
    try {
      const response = await axios.delete(
        `${API_URL}/api/tickets/deleteComment/${ticketDetails.ticketId}/${commentId}`,
        { headers: { Authorization: `Bearer ${getToken()}` } }
      );

      const ticketData = response.data;
      setTicketDetails(ticketData);
      setComments(ticketData.comments || []);
      toast.success("Comment deleted", { toastId: "comment-deleted" });
    } catch (error) {
      console.error("Error deleting comment:", error);
      toast.error("Failed to delete comment", {
        toastId: "comment-delete-error",
      });
    }
  };

  // ---------------------------------------------------------------------
  // Response comments
  // ---------------------------------------------------------------------
  const toggleCommentBox = (responseId) => {
    if (showCommentBoxId === responseId) {
      setShowCommentBoxId(null);
    } else {
      setShowCommentBoxId(responseId);
    }
    setCommentInput("");
    setEditingComment(null);
  };

  const submitComment = async (responseId) => {
    if (!commentInput.trim()) return;
    const commentId = editingComment?.commentId;

    try {
      const url = editingComment
        ? `${API_URL}/api/issues/updateResponseComment/${selectedIssue.issueId}/${responseId}/${commentId}`
        : `${API_URL}/api/issues/addResponseComment/${selectedIssue.issueId}/${responseId}`;

      const method = editingComment ? "PUT" : "POST";

      const bodyData = {
        content: commentInput,
        userId: user?.id,
        userName: user?.name,
      };

      const res = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        body: editingComment ? commentInput : JSON.stringify(bodyData),
      });

      if (res.ok) {
        const wasEditing = !!editingComment;
        setCommentInput("");
        setShowCommentBoxId(null);
        setEditingComment(null);
        handleViewResponse(selectedIssue.issueId);
        toast.success(wasEditing ? "Comment updated!" : "Comment added!", {
          toastId: "response-comment-success",
        });
      } else {
        toast.error("Failed to submit comment", {
          toastId: "response-comment-error",
        });
      }
    } catch (error) {
      console.error("Error submitting comment:", error);
      toast.error("Failed to submit comment", {
        toastId: "response-comment-error",
      });
    }
  };

  const handleEditComment = (responseId, comment) => {
    setShowCommentBoxId(responseId);
    setCommentInput(comment.content);
    setEditingComment(comment);
  };

  const handleDeleteResponseComment = async (responseId, commentId) => {
    try {
      const res = await fetch(
        `${API_URL}/api/issues/deleteResponseComment/${selectedIssue.issueId}/${responseId}/${commentId}`,
        {
          method: "DELETE",
          headers: { Authorization: `Bearer ${getToken()}` },
        }
      );
      if (res.ok) {
        await handleViewResponse(selectedIssue.issueId);
        toast.success("Comment deleted!", {
          toastId: "response-comment-deleted",
        });
      } else {
        toast.error("Failed to delete comment", {
          toastId: "response-comment-delete-error",
        });
      }
    } catch (error) {
      console.error("Error deleting comment:", error);
      toast.error("Failed to delete comment", {
        toastId: "response-comment-delete-error",
      });
    }
  };

  // ---------------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------------
  return (
    <div className="p-4 sm:p-5 bg-[#FAF8FF] cfg-font dark:bg-gray-900 dark:text-gray-100 min-h-screen rounded-lg shadow-lg">
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Sora:wght@600;700&family=Inter:wght@400;500;600&display=swap'); .cfg-heading{font-family:'Sora',sans-serif;color:#1F2937;} .cfg-font{font-family:'Inter',sans-serif;}`}</style>

      <div className="flex flex-col gap-4 mb-5 sm:flex-row sm:justify-between sm:items-center">
        <div className="flex justify-start">
          <h2 className="text-xl font-bold cfg-heading dark:text-white">
            Issues Table
          </h2>
        </div>

        <div className="flex flex-wrap justify-end gap-2">
          <button
            type="button"
            onClick={() => {
              setEditingIssue(null);
              setShowIssueForm(true);
            }}
            className="flex items-center px-3 py-1.5 bg-[#673AB7] text-white rounded-md hover:bg-[#5E35A6] shadow-sm transition"
          >
            <PlusIcon className="w-5 h-5 mr-1" />
            <span className="text-sm font-medium">Add</span>
          </button>
          <button
            type="button"
            onClick={() => setShowFields(!showFields)}
            className="px-3 py-1.5 bg-[#673AB7] text-white hover:bg-[#5E35A6] rounded-md shadow-sm flex items-center transition text-sm font-medium"
          >
            {showFields ? (
              <>
                <FaTimes className="mr-1.5 w-4 h-4" />
                Close
              </>
            ) : (
              <>
                <FaSearch className="mr-1.5 w-4 h-4" />
                Search
              </>
            )}
          </button>
        </div>
      </div>

      {showFields && (
        <form
          onSubmit={handleSearchSubmit}
          className="p-3 bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-[#E5E7EB] dark:border-gray-700 mb-5 w-full"
        >
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-3 items-end">
            {/* Subject */}
            <div>
              <label className="block text-xs font-semibold mb-1 text-[#374151] dark:text-gray-200">
                Subject
              </label>
              <input
                type="text"
                name="subject"
                value={searchParams.subject}
                onChange={handleSearchChange}
                placeholder="Search by subject"
                className="w-full p-2 text-xs border border-[#E5E7EB] rounded-md bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] transition"
              />
            </div>

            {/* Priority */}
            <div>
              <label className="block text-xs font-semibold mb-1 text-[#374151] dark:text-gray-200">
                Priority
              </label>
              <select
                name="priority"
                value={searchParams.priority}
                onChange={handleSearchChange}
                className="w-full p-2 text-xs border border-[#E5E7EB] rounded-md bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] transition"
              >
                <option value="">All</option>
                <option value="High">High</option>
                <option value="Medium">Medium</option>
                <option value="Low">Low</option>
              </select>
            </div>

            {/* User */}
            <div>
              <label className="block text-xs font-semibold mb-1 text-[#374151] dark:text-gray-200">
                User
              </label>
              <select
                name="targetUserId"
                value={searchParams.targetUserId}
                onChange={handleSearchChange}
                className="w-full p-2 text-xs border border-[#E5E7EB] rounded-md bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] transition"
              >
                <option value="">All</option>
                {users.map((u) => (
                  <option key={u.id} value={u.id}>
                    {u.fname} {u.lname}
                  </option>
                ))}
              </select>
            </div>

            {/* Date Range */}
            <div className="col-span-1 sm:col-span-2 md:col-span-3 xl:col-span-1">
              <label className="block text-xs font-semibold mb-1 text-[#374151] dark:text-gray-200">
                Date Range
              </label>
              <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-2">
                <input
                  type="date"
                  name="startDate"
                  value={searchParams.startDate}
                  onChange={handleSearchChange}
                  className="sm:w-1/2 mb-2 sm:mb-0 p-2 text-xs border border-[#E5E7EB] rounded-md bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] transition"
                />
                <span className="text-center sm:text-left text-xs text-[#6B7280] dark:text-gray-300">
                  to
                </span>
                <input
                  type="date"
                  name="endDate"
                  value={searchParams.endDate}
                  onChange={handleSearchChange}
                  className="sm:w-1/2 mt-2 sm:mt-0 p-2 text-xs border border-[#E5E7EB] rounded-md bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] transition"
                />
              </div>
            </div>
          </div>

          {/* Buttons */}
          <div className="flex justify-end gap-2 mt-3">
            <button
              type="submit"
              className="px-3 py-1.5 text-xs bg-[#673AB7] text-white font-medium rounded-md hover:bg-[#5E35A6] shadow-sm transition flex items-center"
            >
              <FaSearch className="mr-1.5" />
              Search
            </button>
            {isSearching && (
              <button
                type="button"
                onClick={handleClearSearch}
                className="px-3 py-1.5 text-xs bg-[#F3F4F6] text-[#374151] font-medium rounded-md hover:bg-[#E5E7EB] transition dark:bg-gray-700 dark:text-gray-200 dark:hover:bg-gray-600 border border-[#E5E7EB] dark:border-gray-600 flex items-center"
              >
                <FaTimes className="mr-1.5" />
                Clear
              </button>
            )}
          </div>
        </form>
      )}

      <div className="overflow-x-auto bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-[#E5E7EB] dark:border-gray-700">
        <table className="w-full border-collapse text-xs">
          <thead>
            <tr className="bg-[#F3F4F6] dark:bg-gray-700 dark:text-white text-left text-[#6B7280]">
              <th className="p-3 border-b border-[#E5E7EB] dark:border-gray-600 font-semibold uppercase tracking-wider">
                S No.
              </th>
              <th className="p-3 border-b border-[#E5E7EB] dark:border-gray-600 font-semibold uppercase tracking-wider">
                Title
              </th>
              <th className="p-3 border-b border-[#E5E7EB] dark:border-gray-600 font-semibold uppercase tracking-wider">
                Priority
              </th>
              <th className="p-3 border-b border-[#E5E7EB] dark:border-gray-600 font-semibold uppercase tracking-wider">
                Severity
              </th>
              <th className="p-3 border-b border-[#E5E7EB] dark:border-gray-600 font-semibold uppercase tracking-wider">
                Type
              </th>
              <th className="p-3 border-b border-[#E5E7EB] dark:border-gray-600 font-semibold uppercase tracking-wider">
                Assigned By
              </th>
              <th className="p-3 border-b border-[#E5E7EB] dark:border-gray-600 font-semibold uppercase tracking-wider">
                Assigned To
              </th>
              <th className="p-3 border-b border-[#E5E7EB] dark:border-gray-600 font-semibold uppercase tracking-wider">
                Reported Date
              </th>
              <th className="p-3 border-b border-[#E5E7EB] dark:border-gray-600 font-semibold uppercase tracking-wider">
                Status
              </th>
              <th className="p-3 border-b border-[#E5E7EB] dark:border-gray-600 font-semibold uppercase tracking-wider">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan="10" className="text-center p-6 text-[#6B7280]">
                  Loading...
                </td>
              </tr>
            ) : issues.length > 0 ? (
              issues.map((issue, index) => (
                <React.Fragment key={issue.issueId}>
                  <tr className="border-b border-[#E5E7EB] dark:border-gray-600 cursor-pointer hover:bg-[#F3F4F6] dark:hover:bg-gray-700 transition-colors duration-150">
                    <td className="p-3 align-middle text-[#374151] dark:text-gray-200">
                      <div className="flex items-center gap-2">
                        <span className="cursor-pointer">
                          {pageNumber * pageSize + index + 1}
                        </span>
                        <FaList
                          title="View Details"
                          className="cursor-pointer text-[#8B5CF6] hover:text-[#673AB7] dark:hover:text-[#E9D5FF] text-sm"
                          onClick={() => handleViewIssue(issue)}
                        />
                      </div>
                    </td>

                    <td
                      className="p-3 align-middle cursor-pointer text-[#374151] dark:text-gray-200 font-medium"
                      onClick={() => handleViewIssue(issue)}
                    >
                      <div className="flex items-center justify-between">
                        <span>{issue.title}</span>
                        <span
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleDropdown(issue.issueId);
                          }}
                          className="ml-2 cursor-pointer"
                        >
                          {expandedIssue === issue.issueId ? (
                            <FaChevronUp className="text-[#6B7280]" />
                          ) : (
                            <FaChevronDown className="text-[#6B7280]" />
                          )}
                        </span>
                      </div>
                    </td>

                    <td className="p-3 align-middle text-[#374151] dark:text-gray-200">
                      {issue.priority}
                    </td>
                    <td className="p-3 align-middle text-[#374151] dark:text-gray-200">
                      {issue.severity}
                    </td>
                    <td className="p-3 align-middle text-[#374151] dark:text-gray-200">
                      {issue.type}
                    </td>
                    <td className="p-3 align-middle text-[#374151] dark:text-gray-200">
                      {issue.reportedByName}
                    </td>
                    <td className="p-3 align-middle text-[#374151] dark:text-gray-200">
                      {(issue.assignedTo || []).map((assignee, idx) => (
                        <span
                          key={idx}
                          className="inline-block bg-[#F3F4F6] dark:bg-gray-700 px-2 py-0.5 rounded mr-1 mb-1 text-[11px] font-medium border border-[#E5E7EB] dark:border-gray-600"
                        >
                          {assignee.name}
                        </span>
                      ))}
                    </td>
                    <td className="p-3 align-middle text-[#374151] dark:text-gray-200">
                      {issue.reportedDate}
                    </td>
                    <td
                      className="p-3 align-middle"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <select
                        className="border border-[#E5E7EB] p-1.5 rounded bg-white text-[#374151] dark:bg-gray-800 dark:text-white dark:border-gray-600 focus:outline-none focus:ring-1 focus:ring-[#673AB7] text-xs"
                        value={issue.statusName}
                        onChange={(e) => {
                          e.stopPropagation();
                          handleStatusChange(issue.issueId, e.target.value, e);
                        }}
                      >
                        {statuses
                          .filter((status) => status.active === true)
                          .map((status) => (
                            <option key={status.id} value={status.name}>
                              {status.name}
                            </option>
                          ))}
                      </select>
                    </td>

                    <td
                      className="p-3 align-middle"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <div className="flex items-center gap-3 flex-wrap">
                        {issue.createdById === user?.id ||
                        user?.accountType === "COMPANY" ? (
                          <>
                            <FaEdit
                              title="Edit"
                              className="cursor-pointer text-[#8B5CF6] hover:text-[#673AB7] dark:hover:text-[#E9D5FF] text-sm"
                              onClick={() => handleEditClick(issue)}
                            />
                            <FaTrash
                              title="Delete"
                              className="cursor-pointer text-[#EF4444] hover:text-[#B91C1C] dark:hover:text-[#FCA5A5] text-sm"
                              onClick={() => {
                                setIssueToDelete(issue);
                                setShowDeleteModal(true);
                              }}
                            />
                          </>
                        ) : null}

                        <FaReply
                          title="Respond"
                          className="cursor-pointer text-[#8B5CF6] hover:text-[#673AB7] dark:hover:text-[#E9D5FF] text-sm"
                          onClick={() => handleResponseClick(issue)}
                        />
                        <FaTicketAlt
                          title="View Ticket"
                          className="cursor-pointer text-[#10B981] hover:text-[#059669] dark:hover:text-emerald-400 text-sm"
                          onClick={() => handleViewTicket(issue)}
                        />
                        <FaCommentDots
                          title="View Response"
                          className="cursor-pointer text-[#8B5CF6] hover:text-[#673AB7] dark:hover:text-[#E9D5FF] text-sm"
                          onClick={() => handleViewResponse(issue.issueId)}
                        />

                        {issue.attachments && issue.attachments.length > 0 && (
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              setSelectedIssue(issue);
                              handleViewAttachment(issue, 0);
                            }}
                            className="text-[#8B5CF6] hover:text-[#673AB7] dark:hover:text-[#E9D5FF] flex items-center gap-1 text-sm"
                            title={
                              issue.attachments.length > 1
                                ? `View ${issue.attachments.length} attachments`
                                : "View attachment"
                            }
                          >
                            <FaEye />
                            {issue.attachments.length > 1 && (
                              <span className="text-[10px] font-bold">
                                {issue.attachments.length}
                              </span>
                            )}
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                  {expandedIssue === issue.issueId && (
                    <tr>
                      <td
                        colSpan="10"
                        className="p-5 bg-[#FAF8FF] dark:bg-gray-800 border-b border-[#E5E7EB] dark:border-gray-700"
                      >
                        <div className="space-y-4">
                          <div>
                            <strong className="text-[#1F2937] dark:text-gray-200">
                              Description:
                            </strong>
                            <p className="mt-1.5 whitespace-pre-wrap text-[#374151] dark:text-gray-300 text-sm">
                              {issue.description}
                            </p>
                          </div>
                          <div>
                            <strong className="text-[#1F2937] dark:text-gray-200">
                              Reproducible Steps:
                            </strong>
                            <p className="mt-1.5 whitespace-pre-wrap text-[#374151] dark:text-gray-300 text-sm">
                              {issue.reproducibleSteps}
                            </p>
                          </div>
                          {issue.tags && issue.tags.length > 0 && (
                            <div>
                              <strong className="text-[#1F2937] dark:text-gray-200">
                                Tags:
                              </strong>
                              <div className="flex flex-wrap gap-2 mt-2">
                                {issue.tags.map((tag, idx) => (
                                  <span
                                    key={idx}
                                    className="px-2.5 py-1 bg-[#F3E8FF] text-[#673AB7] border border-[#E9D5FF] text-xs rounded-full font-medium dark:bg-purple-900/30 dark:border-purple-800 dark:text-purple-300"
                                  >
                                    {tag}
                                  </span>
                                ))}
                              </div>
                            </div>
                          )}
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))
            ) : (
              <tr>
                <td colSpan="10" className="text-center p-8 text-[#6B7280]">
                  No records found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {totalPages > 0 && (
        <div className="mt-4 flex flex-col sm:flex-row justify-between items-center gap-4 bg-white dark:bg-gray-800 p-3 rounded-lg border border-[#E5E7EB] dark:border-gray-700 shadow-sm">
          <div className="flex items-center gap-2 w-full sm:w-auto relative z-10">
            <span className="text-sm text-[#374151] dark:text-gray-300 whitespace-nowrap">
              Items per page:
            </span>
            <Select
              className="w-24 text-sm"
              classNamePrefix="select"
              menuPortalTarget={
                typeof window !== "undefined" ? document.body : null
              }
              menuPosition="fixed"
              styles={{
                control: (baseStyles) => {
                  const isDark =
                    typeof window !== "undefined" &&
                    document.documentElement.classList.contains("dark");
                  return {
                    ...baseStyles,
                    backgroundColor: isDark ? "#374151" : "#ffffff",
                    color: isDark ? "#ffffff" : "#000000",
                    borderColor: isDark ? "#4b5563" : "#E5E7EB",
                    minHeight: "32px",
                    fontSize: "0.875rem",
                    zIndex: 10,
                  };
                },
                singleValue: (base) => {
                  const isDark =
                    typeof window !== "undefined" &&
                    document.documentElement.classList.contains("dark");
                  return {
                    ...base,
                    color: isDark ? "#ffffff" : "#374151",
                  };
                },
                menu: (base) => {
                  const isDark =
                    typeof window !== "undefined" &&
                    document.documentElement.classList.contains("dark");
                  return {
                    ...base,
                    backgroundColor: isDark ? "#1f2937" : "#ffffff",
                    color: isDark ? "#ffffff" : "#000000",
                    zIndex: 9999,
                  };
                },
                menuPortal: (base) => ({
                  ...base,
                  zIndex: 9999,
                }),
                option: (base, state) => {
                  const isDark =
                    typeof window !== "undefined" &&
                    document.documentElement.classList.contains("dark");
                  return {
                    ...base,
                    backgroundColor: state.isFocused
                      ? isDark
                        ? "#4b5563"
                        : "#F3F4F6"
                      : isDark
                      ? "#1f2937"
                      : "#ffffff",
                    color: isDark ? "#ffffff" : "#374151",
                    cursor: "pointer",
                  };
                },
              }}
              value={{ value: pageSize, label: pageSize.toString() }}
              // changing pageSize recreates fetchPage, and the loader effect refetches
              onChange={(selectedOption) =>
                setPageSize(Number(selectedOption.value))
              }
              options={[
                { value: 5, label: "5" },
                { value: 10, label: "10" },
                { value: 20, label: "20" },
                { value: 50, label: "50" },
              ]}
            />
          </div>
          <div className="flex flex-wrap justify-center items-center gap-2 w-full sm:w-auto">
            <div className="flex items-center gap-2">
              <button
                onClick={() => fetchPage(0)}
                className="px-3 py-1.5 bg-[#F3E8FF] hover:bg-[#E9D5FF] text-sm font-medium text-[#673AB7] rounded disabled:opacity-50 disabled:hover:bg-[#F3E8FF] transition-colors"
                disabled={pageNumber === 0}
              >
                First
              </button>
              <button
                onClick={() => fetchPage(Math.max(pageNumber - 1, 0))}
                className="px-3 py-1.5 bg-[#F3E8FF] hover:bg-[#E9D5FF] text-sm font-medium text-[#673AB7] rounded disabled:opacity-50 disabled:hover:bg-[#F3E8FF] transition-colors"
                disabled={pageNumber === 0}
              >
                Prev
              </button>
            </div>

            <span className="text-sm font-medium whitespace-nowrap text-[#374151] dark:text-gray-300">
              Page {pageNumber + 1} of {totalPages}
            </span>

            <div className="flex items-center gap-2">
              <button
                onClick={() =>
                  fetchPage(Math.min(pageNumber + 1, totalPages - 1))
                }
                className="px-3 py-1.5 bg-[#F3E8FF] hover:bg-[#E9D5FF] text-sm font-medium text-[#673AB7] rounded disabled:opacity-50 disabled:hover:bg-[#F3E8FF] transition-colors"
                disabled={pageNumber >= totalPages - 1}
              >
                Next
              </button>
              <button
                onClick={() => fetchPage(totalPages - 1)}
                className="px-3 py-1.5 bg-[#F3E8FF] hover:bg-[#E9D5FF] text-sm font-medium text-[#673AB7] rounded disabled:opacity-50 disabled:hover:bg-[#F3E8FF] transition-colors"
                disabled={pageNumber >= totalPages - 1}
              >
                Last
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Issue Detail Modal */}
      {isModalOpen && selectedIssue && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm p-2 sm:p-4">
          <div className="bg-white dark:bg-gray-800 dark:text-white p-6 sm:p-8 rounded-xl w-full max-w-4xl mx-auto max-h-[90vh] overflow-y-auto shadow-2xl border border-[#E5E7EB] dark:border-gray-700">
            {/* Header */}
            <div className="flex justify-between items-center border-b border-[#E5E7EB] dark:border-gray-600 pb-4 mb-4">
              <h2 className="text-xl sm:text-2xl font-bold cfg-heading dark:text-white">
                Issue Details:{" "}
                <span className="text-[#673AB7]">{selectedIssue.title}</span>
              </h2>
              <button
                onClick={() => setIsModalOpen(false)}
                className="text-[#6B7280] hover:text-[#EF4444] dark:text-gray-300 text-xl transition-colors"
              >
                <FaTimes />
              </button>
            </div>

            {/* Basic Info */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6 text-[#374151] dark:text-gray-300">
              <div className="space-y-2">
                <div>
                  <span className="font-semibold text-[#1F2937] dark:text-gray-200">
                    Status:
                  </span>
                  <span className="ml-2 px-2 py-1 rounded text-xs bg-[#F3F4F6] text-[#374151] dark:bg-gray-700 dark:text-gray-200 border border-[#E5E7EB] dark:border-gray-600">
                    {selectedIssue.statusName}
                  </span>
                </div>
                <div>
                  <span className="font-semibold text-[#1F2937] dark:text-gray-200">
                    Priority:
                  </span>{" "}
                  {selectedIssue.priority}
                </div>
                <div>
                  <span className="font-semibold text-[#1F2937] dark:text-gray-200">
                    Severity:
                  </span>{" "}
                  {selectedIssue.severity}
                </div>
                <div>
                  <span className="font-semibold text-[#1F2937] dark:text-gray-200">
                    Type:
                  </span>{" "}
                  {selectedIssue.type}
                </div>
              </div>
              <div className="space-y-2">
                <div>
                  <span className="font-semibold text-[#1F2937] dark:text-gray-200">
                    Environment:
                  </span>{" "}
                  {selectedIssue.environment}
                </div>
                <div>
                  <span className="font-semibold text-[#1F2937] dark:text-gray-200">
                    Reported By:
                  </span>{" "}
                  {selectedIssue.reportedByName}
                </div>
                <div>
                  <span className="font-semibold text-[#1F2937] dark:text-gray-200">
                    Reported Date:
                  </span>{" "}
                  {selectedIssue.reportedDate}
                </div>
                <div>
                  <span className="font-semibold text-[#1F2937] dark:text-gray-200">
                    Expected Fix Date:
                  </span>{" "}
                  {selectedIssue.expectedFixDate || "Not specified"}
                </div>
              </div>
            </div>

            {/* Description and Steps */}
            <div className="bg-[#FAF8FF] border border-[#E5E7EB] dark:bg-gray-700 dark:border-gray-600 p-4 rounded-lg mb-4">
              <h3 className="font-semibold mb-2 text-[#1F2937] dark:text-gray-200">
                Description
              </h3>
              <p className="whitespace-pre-wrap break-words text-[#374151] dark:text-gray-300 text-sm">
                {selectedIssue.description}
              </p>
            </div>
            <div className="bg-[#FAF8FF] border border-[#E5E7EB] dark:bg-gray-700 dark:border-gray-600 p-4 rounded-lg mb-4">
              <h3 className="font-semibold mb-2 text-[#1F2937] dark:text-gray-200">
                Reproducible Steps
              </h3>
              <p className="whitespace-pre-wrap break-words text-[#374151] dark:text-gray-300 text-sm">
                {selectedIssue.reproducibleSteps}
              </p>
            </div>

            {/* Tags */}
            {selectedIssue.tags && selectedIssue.tags.length > 0 && (
              <div className="mb-6">
                <h3 className="font-semibold mb-2 text-[#1F2937] dark:text-gray-200">
                  Tags
                </h3>
                <div className="flex flex-wrap gap-2">
                  {selectedIssue.tags.map((tag, idx) => (
                    <span
                      key={idx}
                      className="px-2 py-1 bg-[#F3E8FF] text-[#673AB7] dark:bg-purple-900 dark:text-purple-200 text-xs font-medium rounded-full"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            )}

            {/* Assigned To */}
            <div className="mb-6">
              <h3 className="font-semibold mb-2 text-[#1F2937] dark:text-gray-200">
                Assigned To
              </h3>
              <div className="flex flex-wrap gap-2">
                {selectedIssue.assignedTo &&
                selectedIssue.assignedTo.length > 0 ? (
                  selectedIssue.assignedTo.map((assignee, idx) => (
                    <span
                      key={idx}
                      className="px-3 py-1 bg-[#F3F4F6] text-[#374151] border border-[#E5E7EB] dark:bg-gray-700 dark:border-gray-600 dark:text-gray-200 rounded-full text-sm font-medium"
                    >
                      {assignee.name}
                    </span>
                  ))
                ) : (
                  <span className="text-[#6B7280]">Not assigned</span>
                )}
              </div>
            </div>

            {/* Status Updates */}
            <div className="bg-[#FAF8FF] border border-[#E5E7EB] dark:bg-gray-700 dark:border-gray-600 rounded-lg p-4">
              <h3 className="font-semibold mb-3 text-[#1F2937] dark:text-gray-200">
                Status History
              </h3>
              {selectedIssue.statusUpdates &&
              selectedIssue.statusUpdates.length > 0 ? (
                <ul className="space-y-3">
                  {selectedIssue.statusUpdates.map((update, idx) => (
                    <li
                      key={idx}
                      className="border-l-4 border-[#8B5CF6] pl-3 py-1"
                    >
                      <div className="flex flex-wrap items-baseline gap-1 text-[#374151] dark:text-gray-200 text-sm">
                        <span className="font-medium text-[#1F2937] dark:text-white">
                          {update.updatedByName}
                        </span>
                        <span>changed status from</span>
                        <span className="font-medium">
                          {update.oldStatus || "_"}
                        </span>
                        <span>to</span>
                        <span className="font-medium text-[#673AB7] dark:text-[#E9D5FF]">
                          {update.newStatus}
                        </span>
                      </div>
                      <div className="text-xs text-[#6B7280] dark:text-gray-400 mt-1">
                        {new Date(update.updatedAt).toLocaleString()}
                      </div>
                      {update.remark && (
                        <div className="text-sm mt-1 italic text-[#6B7280] dark:text-gray-400">
                          <span className="font-medium not-italic text-[#374151] dark:text-gray-300">
                            Remark:
                          </span>{" "}
                          {update.remark}
                        </div>
                      )}
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="text-[#6B7280]">No status updates available</p>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Ticket Modal */}
      {isTicketModalOpen && selectedIssue && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm p-2 sm:p-4">
          <div className="bg-white dark:bg-gray-800 dark:text-white p-6 rounded-xl w-full max-w-4xl mx-auto max-h-[90vh] overflow-y-auto shadow-xl border border-[#E5E7EB] dark:border-gray-700">
            {/* Header */}
            <div className="flex justify-between items-center border-b border-[#E5E7EB] dark:border-gray-700 pb-4 mb-4">
              <h2 className="text-xl sm:text-2xl font-bold cfg-heading dark:text-white text-[#1F2937] flex items-center gap-2">
                🧾 Ticket Details
              </h2>
              <button
                onClick={() => {
                  setIsTicketModalOpen(false);
                  setIsCommentBoxOpen(false);
                  setNewComment("");
                }}
                className="text-[#6B7280] hover:text-[#EF4444] dark:text-white text-xl transition duration-150"
              >
                <FaTimes />
              </button>
            </div>

            {/* Basic Info */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-y-2 sm:gap-4 mb-6 text-sm sm:text-base text-[#374151] dark:text-gray-200">
              <div>
                <span className="font-semibold text-[#1F2937] dark:text-white">
                  Assigned To:
                </span>
                <span className="mx-2">
                  {selectedIssue.assignedTo?.map((u) => u.name).join(", ") ||
                    "_"}
                </span>
              </div>
              <div>
                <span className="font-semibold text-[#1F2937] dark:text-white">
                  Status:
                </span>
                <span className="mx-2">
                  {selectedIssue.statusUpdates?.[
                    selectedIssue.statusUpdates.length - 1
                  ]?.newStatus === "PENDING_APPROVAL" &&
                  selectedIssue.createdById === user?.id ? (
                    <div className="flex items-center flex-wrap gap-2 mt-1">
                      <span className="inline-block px-2 py-1 rounded text-xs font-medium bg-[#F3E8FF] text-[#673AB7] border border-[#E9D5FF] dark:bg-purple-900 dark:text-purple-200">
                        {selectedIssue.statusUpdates?.[
                          selectedIssue.statusUpdates.length - 1
                        ]?.newStatus || "Pending"}
                      </span>
                      <button
                        className="text-green-600 hover:scale-110"
                        title="Approve"
                        onClick={() => {
                          setActionType("APPROVED");
                          setShowRemarkInput(true);
                        }}
                      >
                        ✅
                      </button>
                      <button
                        className="text-red-600 hover:scale-110"
                        title="Reject"
                        onClick={() => {
                          setActionType("REJECTED");
                          setShowRemarkInput(true);
                        }}
                      >
                        ❌
                      </button>
                    </div>
                  ) : (
                    <span className="inline-block px-2 py-1 rounded text-xs font-medium bg-[#F3F4F6] text-[#374151] border border-[#E5E7EB] dark:bg-gray-700 dark:text-gray-200 dark:border-gray-600">
                      {selectedIssue.statusUpdates?.[
                        selectedIssue.statusUpdates.length - 1
                      ]?.newStatus || selectedIssue.statusName}
                    </span>
                  )}
                </span>

                {/* Remark Input */}
                {showRemarkInput && (
                  <div className="mt-3 bg-[#FAF8FF] p-3 rounded border border-[#E5E7EB] dark:bg-gray-700 dark:border-gray-600 dark:text-white">
                    <textarea
                      rows="3"
                      value={remarkInput}
                      onChange={(e) => setRemarkInput(e.target.value)}
                      className="w-full border border-[#E5E7EB] rounded-md p-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-600 dark:border-gray-500 dark:text-white"
                      placeholder="Enter your remark..."
                    />
                    <div className="flex gap-2 mt-2">
                      <button
                        onClick={() =>
                          handleApproveOrReject(
                            selectedIssue.issueId,
                            actionType,
                            remarkInput
                          )
                        }
                        className="bg-[#673AB7] hover:bg-[#5E35A6] text-white text-sm px-4 py-1.5 rounded-md"
                      >
                        Submit
                      </button>
                      <button
                        onClick={() => {
                          setRemarkInput("");
                          setShowRemarkInput(false);
                        }}
                        className="bg-[#F3F4F6] hover:bg-[#E5E7EB] text-[#374151] border border-[#E5E7EB] text-sm px-4 py-1.5 rounded-md dark:bg-gray-600 dark:text-gray-200 dark:border-gray-500"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Status + Comments */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
              {/* Status Updates */}
              <div className="bg-[#FAF8FF] rounded-lg p-4 border border-[#E5E7EB] dark:bg-gray-700 dark:border-gray-600 dark:text-white">
                <div className="flex justify-between items-center mb-3 border-b border-[#E5E7EB] dark:border-gray-600 pb-2">
                  <h3 className="text-base sm:text-lg font-semibold text-[#1F2937] dark:text-white">
                    📌 Status Updates
                  </h3>
                </div>
                <div className="max-h-[220px] overflow-y-auto pr-1.5 text-sm space-y-3">
                  {selectedIssue.statusUpdates?.length > 0 ? (
                    <ul className="list-none space-y-3 border-l-2 border-[#E9D5FF] pl-3 ml-1">
                      {selectedIssue.statusUpdates.map((update, idx) => (
                        <li key={idx} className="relative">
                          <span className="absolute -left-[19px] top-1 w-3 h-3 bg-[#8B5CF6] rounded-full border-2 border-[#FAF8FF] dark:border-gray-700"></span>
                          <div className="flex flex-wrap gap-1 text-[#374151] dark:text-gray-200">
                            <span className="font-semibold text-[#1F2937] dark:text-white">
                              {update.updatedByName}
                            </span>
                            <span>changed status from</span>
                            <span className="font-medium bg-[#F3F4F6] px-1 rounded dark:bg-gray-600">
                              {update.oldStatus}
                            </span>
                            <span>to</span>
                            <span className="font-bold text-[#673AB7] dark:text-[#E9D5FF]">
                              {update.newStatus}
                            </span>
                          </div>
                          <div className="text-[#6B7280] text-xs mt-1 dark:text-gray-400">
                            {new Date(update.updatedAt).toLocaleString()}
                          </div>
                          {update.remark && (
                            <div className="text-[#374151] bg-white border border-[#E5E7EB] p-2 rounded mt-1 text-xs italic dark:bg-gray-800 dark:border-gray-600 dark:text-gray-300">
                              <span className="font-semibold not-italic">
                                Remark:
                              </span>{" "}
                              {update.remark}
                            </div>
                          )}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p className="text-[#6B7280] dark:text-gray-400">
                      No status updates found.
                    </p>
                  )}
                </div>
              </div>

              {/* Comments */}
              <div className="bg-[#FAF8FF] rounded-lg p-4 border border-[#E5E7EB] shadow-sm dark:bg-gray-800 dark:border-gray-700">
                <div className="flex justify-between items-center mb-3 border-b border-[#E5E7EB] dark:border-gray-700 pb-2">
                  <div className="flex items-center space-x-2">
                    <h3 className="text-lg font-semibold text-[#1F2937] dark:text-white">
                      Comments
                    </h3>
                    <span className="bg-[#F3E8FF] text-[#673AB7] border border-[#E9D5FF] text-xs font-bold px-2.5 py-0.5 rounded-full dark:bg-purple-900 dark:text-purple-300 dark:border-purple-700">
                      {comments.length}
                    </span>
                  </div>
                  <button
                    onClick={() => setIsCommentBoxOpen(true)}
                    className="flex items-center space-x-1 text-[#673AB7] hover:text-[#5E35A6] dark:text-purple-400 dark:hover:text-purple-300 transition-colors bg-[#F3E8FF] px-2 py-1 rounded dark:bg-purple-900/30"
                  >
                    <FaPlusCircle className="text-sm" />
                    <span className="text-xs font-semibold">Add Comment</span>
                  </button>
                </div>

                {/* Comments list */}
                <div className="space-y-4 max-h-64 overflow-y-auto pr-2 scrollbar-thin scrollbar-thumb-[#E5E7EB] scrollbar-track-transparent dark:scrollbar-thumb-gray-600">
                  {comments.length > 0 ? (
                    comments.map((comment, idx) => (
                      <div
                        key={comment.commentId || idx}
                        className="group relative p-3 bg-white rounded-lg border border-[#E5E7EB] hover:shadow-md transition-shadow dark:bg-gray-700 dark:border-gray-600"
                      >
                        {editingCommentId === (comment.commentId || idx) ? (
                          <div className="space-y-2">
                            <textarea
                              value={editedComment}
                              onChange={(e) => {
                                if (e.target.value.length <= 150) {
                                  setEditedComment(e.target.value);
                                }
                              }}
                              className="w-full p-2 text-sm border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-600 dark:border-gray-500 dark:text-white"
                              rows={3}
                              maxLength={150}
                              autoFocus
                            />
                            <div className="flex justify-between items-center">
                              <span className="text-xs text-[#6B7280] dark:text-gray-400">
                                {editedComment.length}/150 characters
                              </span>
                              {editedComment.length > 150 && (
                                <span className="text-xs text-[#EF4444]">
                                  Comment must not exceed 150 characters
                                </span>
                              )}
                            </div>
                            <div className="flex space-x-2">
                              <button
                                onClick={() => {
                                  if (editedComment.length > 150) return;
                                  handleUpdateComment(
                                    ticketDetails.ticketId,
                                    comment.commentId || idx,
                                    editedComment
                                  );
                                }}
                                disabled={editedComment.length > 150}
                                className={`px-3 py-1.5 text-xs font-semibold rounded-md ${
                                  editedComment.length > 150
                                    ? "bg-[#F3F4F6] text-[#9CA3AF] cursor-not-allowed dark:bg-gray-600 dark:text-gray-400 border border-[#E5E7EB] dark:border-gray-500"
                                    : "bg-[#673AB7] text-white hover:bg-[#5E35A6]"
                                }`}
                              >
                                Update
                              </button>
                              <button
                                onClick={() => {
                                  setEditingCommentId(null);
                                  setEditedComment("");
                                }}
                                className="px-3 py-1.5 text-xs font-semibold text-[#374151] bg-[#F3F4F6] hover:bg-[#E5E7EB] border border-[#E5E7EB] rounded-md dark:bg-gray-600 dark:text-gray-300 dark:hover:bg-gray-500 dark:border-gray-500"
                              >
                                Cancel
                              </button>
                            </div>
                          </div>
                        ) : (
                          <>
                            <p className="text-sm text-[#374151] dark:text-gray-200 break-words overflow-hidden">
                              {comment.content}
                            </p>
                            <div className="mt-2 flex items-center justify-between">
                              <div className="flex items-center space-x-2">
                                <span className="text-xs font-semibold text-[#1F2937] dark:text-gray-300">
                                  {comment.userName}
                                </span>
                                <span className="text-xs text-[#D1D5DB] dark:text-gray-500">
                                  •
                                </span>
                                <span className="text-xs text-[#6B7280] dark:text-gray-400">
                                  {new Date(comment.createdAt).toLocaleString(
                                    "en-US",
                                    {
                                      month: "short",
                                      day: "numeric",
                                      hour: "2-digit",
                                      minute: "2-digit",
                                    }
                                  )}
                                </span>
                              </div>
                              {comment.userId === user?.id && (
                                <div className="flex space-x-2 opacity-0 group-hover:opacity-100 transition-opacity">
                                  <button
                                    onClick={() => {
                                      setEditingCommentId(
                                        comment.commentId || idx
                                      );
                                      setEditedComment(comment.content);
                                    }}
                                    className="text-[#8B5CF6] hover:text-[#673AB7] p-1 rounded-full hover:bg-[#F3E8FF] dark:hover:bg-gray-600 transition"
                                    title="Edit"
                                  >
                                    <FaEdit className="w-3.5 h-3.5" />
                                  </button>
                                  <button
                                    onClick={() =>
                                      handleDeleteComment(
                                        comment.commentId || idx
                                      )
                                    }
                                    className="text-[#EF4444] hover:text-[#B91C1C] p-1 rounded-full hover:bg-[#FEF2F2] dark:hover:bg-gray-600 transition"
                                    title="Delete"
                                  >
                                    <FaTrash className="w-3.5 h-3.5" />
                                  </button>
                                </div>
                              )}
                            </div>
                          </>
                        )}
                      </div>
                    ))
                  ) : (
                    <div className="text-center py-6">
                      <FaCommentAlt className="h-10 w-10 mx-auto text-[#E5E7EB] dark:text-gray-600 mb-2" />
                      <p className="text-sm text-[#6B7280] dark:text-gray-400">
                        No comments yet. Be the first to comment!
                      </p>
                    </div>
                  )}
                </div>

                {/* Comment Input */}
                {isCommentBoxOpen && (
                  <div className="mt-4 bg-white dark:bg-gray-700 p-3 rounded-lg border border-[#E5E7EB] dark:border-gray-600 shadow-sm">
                    <textarea
                      rows="3"
                      value={newComment}
                      onChange={(e) => {
                        if (e.target.value.length <= 150) {
                          setNewComment(e.target.value);
                          setCommentLengthError("");
                        } else {
                          setCommentLengthError(
                            "comment must not exceed 150 characters"
                          );
                        }
                      }}
                      className="w-full border border-[#E5E7EB] rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] text-sm dark:bg-gray-800 dark:border-gray-600 dark:text-white"
                      placeholder="Write your comment..."
                    />
                    <div className="flex justify-between items-center mt-1">
                      <span className="text-xs text-[#6B7280] dark:text-gray-400">
                        {newComment.length}/150 characters
                      </span>
                      {commentLengthError && (
                        <span className="text-xs text-[#EF4444]">
                          {commentLengthError}
                        </span>
                      )}
                    </div>
                    <button
                      onClick={handleAddComment}
                      disabled={newComment.length > 150}
                      className={`mt-2 bg-[#673AB7] hover:bg-[#5E35A6] text-white text-sm font-semibold px-4 py-1.5 rounded-md transition w-full sm:w-auto ${
                        newComment.length > 150
                          ? "opacity-50 cursor-not-allowed"
                          : ""
                      }`}
                    >
                      Submit Comment
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Add / Edit Issue Form Modal */}
      {showIssueForm && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm px-4 sm:px-6 lg:px-8">
          <div className="relative w-full max-w-md sm:max-w-lg md:max-w-xl lg:max-w-3xl max-h-[90vh] bg-white dark:bg-gray-800 rounded-xl shadow-2xl transition-all duration-300 transform scale-100 flex flex-col border border-[#E5E7EB] dark:border-gray-700">
            <div className="sticky top-0 z-20 flex items-center justify-between bg-white dark:bg-gray-800 p-4 border-b border-[#E5E7EB] dark:border-gray-700 rounded-t-xl">
              <h2 className="text-xl font-bold cfg-heading text-[#1F2937] dark:text-white">
                {editingIssue ? "Edit Issue" : "Add Issue"}
              </h2>
              <button
                onClick={() => {
                  setShowIssueForm(false);
                  setEditingIssue(null);
                }}
                className="text-[#6B7280] hover:text-[#EF4444] dark:text-gray-300 transition-colors"
                aria-label="Close modal"
              >
                <XMarkIcon className="w-6 h-6" />
              </button>
            </div>
            <div className="overflow-y-auto px-5 sm:px-6 md:px-8 py-4 bg-[#FAF8FF] dark:bg-gray-800 rounded-b-xl">
              <IssuesForm
                editData={editingIssue}
                onIssueCreated={handleIssueCreated}
                onIssueUpdated={handleIssueUpdated}
                onClose={() => {
                  setShowIssueForm(false);
                  setEditingIssue(null);
                }}
              />
            </div>
          </div>
        </div>
      )}

      {/* Response Modal */}
      {isResponseModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm ">
          <div className="bg-white p-6 rounded-xl w-96 shadow-2xl relative dark:bg-gray-800 dark:text-white border border-[#E5E7EB] dark:border-gray-700">
            <h2 className="text-xl font-bold cfg-heading text-[#1F2937] dark:text-white mb-4">
              Add Response
            </h2>
            <textarea
              name="content"
              value={responseData.content}
              onChange={handleInputChange}
              placeholder="Type your response..."
              className="w-full border border-[#E5E7EB] p-2 rounded-md mb-4 dark:bg-gray-700 dark:text-white dark:border-gray-600 focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] text-sm"
              rows={4}
            />
            <div className="mb-4">
              <input
                type="file"
                onChange={handleFileChange}
                className="w-full text-sm text-[#6B7280] file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-[#F3E8FF] file:text-[#673AB7] hover:file:bg-[#E9D5FF] transition"
                multiple
              />
            </div>
            {responseData.files.length > 0 && (
              <div className="mb-4 bg-[#FAF8FF] dark:bg-gray-700 p-2 rounded border border-[#E5E7EB] dark:border-gray-600">
                <p className="text-sm font-semibold text-[#1F2937] dark:text-white mb-1">
                  Selected files:
                </p>
                <ul className="text-xs text-[#374151] dark:text-gray-300 space-y-1">
                  {responseData.files.map((file, index) => (
                    <li key={index} className="flex items-center gap-1">
                      📄 {file.name}
                    </li>
                  ))}
                </ul>
              </div>
            )}
            <div className="flex justify-end gap-2 mt-2">
              <button
                onClick={() => setIsResponseModalOpen(false)}
                className="bg-[#F3F4F6] text-[#374151] px-4 py-2 rounded-md hover:bg-[#E5E7EB] font-semibold text-sm transition"
              >
                Cancel
              </button>
              <button
                onClick={handleResponseSubmit}
                className="bg-[#673AB7] text-white px-4 py-2 rounded-md hover:bg-[#5E35A6] font-semibold text-sm transition"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}

      {/* View Responses Modal */}
      {isViewModalOpen && selectedIssue && (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex justify-center items-center z-50">
          <div className="bg-white rounded-2xl w-full max-w-3xl p-6 shadow-2xl relative dark:bg-gray-800 dark:text-white border border-[#E5E7EB] dark:border-gray-700">
            <h2 className="text-2xl font-bold cfg-heading text-[#673AB7] dark:text-[#E9D5FF] mb-6 border-b border-[#E5E7EB] dark:border-gray-700 pb-3">
              {selectedIssue.title}
            </h2>

            <div className="space-y-5 max-h-[70vh] overflow-y-auto pr-2 scrollbar-thin scrollbar-thumb-[#E5E7EB] dark:scrollbar-thumb-gray-600">
              {issueResponses.length === 0 ? (
                <div className="text-center py-8">
                  <p className="text-[#6B7280] dark:text-gray-400 italic">
                    No responses available.
                  </p>
                </div>
              ) : (
                issueResponses.map((res, idx) => (
                  <div
                    key={res.id || idx}
                    className="bg-[#FAF8FF] border border-[#E5E7EB] rounded-lg p-4 shadow-sm dark:bg-gray-700 dark:border-gray-600"
                  >
                    <div className="flex justify-between items-start dark:text-white">
                      <div className="pr-4">
                        <p className="text-sm font-bold text-[#1F2937] dark:text-white">
                          {res.userName}
                        </p>
                        <p className="text-sm text-[#374151] mt-2 dark:text-gray-200 whitespace-pre-wrap">
                          {res.content}
                        </p>
                        <p className="text-xs text-[#6B7280] font-medium mt-3 dark:text-gray-400">
                          Posted on: {new Date(res.createdAt).toLocaleString()}
                        </p>
                      </div>

                      <div className="flex gap-2 items-center text-lg bg-white dark:bg-gray-800 p-1.5 rounded-md border border-[#E5E7EB] dark:border-gray-600 shadow-sm">
                        <button
                          onClick={() => toggleCommentBox(res.id)}
                          title="Add Comment"
                          className="text-[#8B5CF6] hover:text-[#673AB7] p-1.5 rounded hover:bg-[#F3E8FF] dark:hover:bg-gray-600 transition"
                        >
                          <FaCommentAlt className="w-4 h-4" />
                        </button>

                        {res.userId === user?.id && (
                          <>
                            <button
                              title="Edit Response"
                              onClick={() => handleEditResponse(res)}
                              className="text-[#8B5CF6] hover:text-[#673AB7] p-1.5 rounded hover:bg-[#F3E8FF] dark:hover:bg-gray-600 transition"
                            >
                              <FaEdit className="w-4 h-4" />
                            </button>
                            <button
                              title="Delete Response"
                              onClick={() => handleDeleteResponse(res.id)}
                              className="text-[#EF4444] hover:text-[#B91C1C] p-1.5 rounded hover:bg-[#FEF2F2] dark:hover:bg-gray-600 transition"
                            >
                              <FaTrash className="w-4 h-4" />
                            </button>
                          </>
                        )}

                        {res.attachment && res.attachment.length > 0 && (
                          <>
                            <button
                              title="View Attachment"
                              onClick={() =>
                                viewResponseAttachment(
                                  selectedIssue.issueId,
                                  res.id,
                                  res.attachment[0]
                                )
                              }
                              className="text-green-600 hover:text-green-800 p-1.5 rounded hover:bg-green-50 dark:hover:bg-gray-600 transition"
                            >
                              <FaEye className="w-4 h-4" />
                            </button>
                            <button
                              title="Download Attachment"
                              onClick={() =>
                                downloadResponseAttachment(
                                  selectedIssue.issueId,
                                  res.id,
                                  res.attachment[0]
                                )
                              }
                              className="text-[#6B7280] hover:text-[#374151] p-1.5 rounded hover:bg-[#F3F4F6] dark:hover:bg-gray-600 transition"
                            >
                              <FaDownload className="w-4 h-4" />
                            </button>
                          </>
                        )}
                      </div>
                    </div>

                    {/* Comments */}
                    <div className="mt-4 space-y-3 pl-2 border-l-2 border-[#E5E7EB] dark:border-gray-600 ml-2">
                      {res.comments?.map((comment) => (
                        <div
                          key={comment.commentId}
                          className="bg-white dark:bg-gray-800 border border-[#E5E7EB] dark:border-gray-600 border-l-4 border-l-[#8B5CF6] p-3 rounded-md shadow-sm max-w-full"
                        >
                          <p className="text-sm break-words whitespace-pre-wrap text-[#374151] dark:text-gray-200">
                            <span className="font-bold text-[#1F2937] dark:text-white">
                              {comment.userName || "Unknown"}:
                            </span>{" "}
                            {comment.content || "No comment text"}
                          </p>
                          <div className="flex justify-between items-center mt-2">
                            <p className="text-xs font-medium text-[#6B7280] dark:text-gray-400">
                              {new Date(comment.createdAt).toLocaleString()}
                            </p>

                            {comment.userId === user?.id && (
                              <div className="flex gap-3 flex-wrap">
                                <button
                                  onClick={() =>
                                    handleEditComment(res.id, comment)
                                  }
                                  className="text-[#8B5CF6] hover:text-[#673AB7] text-xs font-semibold flex items-center gap-1 transition"
                                  title="Edit Comment"
                                >
                                  <FaEdit /> <span>Edit</span>
                                </button>
                                <button
                                  onClick={() =>
                                    handleDeleteResponseComment(
                                      res.id,
                                      comment.commentId
                                    )
                                  }
                                  className="text-[#EF4444] hover:text-[#B91C1C] text-xs font-semibold flex items-center gap-1 transition"
                                  title="Delete Comment"
                                >
                                  <FaTrash /> <span>Delete</span>
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>

                    {/* Comment Input */}
                    {showCommentBoxId === res.id && (
                      <div className="mt-4 bg-white dark:bg-gray-800 p-3 rounded-lg border border-[#E5E7EB] dark:border-gray-600 shadow-sm">
                        <textarea
                          rows={2}
                          className="w-full p-2 border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] text-sm dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                          value={commentInput}
                          onChange={(e) => {
                            if (e.target.value.length <= 150) {
                              setCommentInput(e.target.value);
                            }
                          }}
                          placeholder="Write your comment..."
                          maxLength={150}
                        ></textarea>
                        <div className="flex justify-between items-center mt-1">
                          <span className="text-xs text-[#6B7280] dark:text-gray-400 font-medium">
                            {commentInput.length}/150 characters
                          </span>
                          {commentInput.length > 150 && (
                            <span className="text-xs text-[#EF4444] font-medium">
                              comment must not exceed 150 characters
                            </span>
                          )}
                        </div>
                        <div className="flex justify-end mt-2 gap-2">
                          <button
                            onClick={() => toggleCommentBox(res.id)}
                            className="px-3 py-1.5 text-sm font-semibold bg-[#F3F4F6] text-[#374151] hover:bg-[#E5E7EB] rounded-md transition dark:bg-gray-600 dark:text-gray-200 dark:hover:bg-gray-500"
                          >
                            Cancel
                          </button>
                          <button
                            onClick={() => submitComment(res.id)}
                            disabled={commentInput.length > 150}
                            className={`px-4 py-1.5 bg-[#673AB7] text-white font-semibold rounded-md hover:bg-[#5E35A6] text-sm transition ${
                              commentInput.length > 150
                                ? "opacity-50 cursor-not-allowed"
                                : ""
                            }`}
                          >
                            {editingComment ? "Update" : "Comment"}
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                ))
              )}
            </div>

            <button
              onClick={() => {
                setIsViewModalOpen(false);
                setShowCommentBoxId(null);
                setCommentInput("");
                setEditingComment(null);
              }}
              className="absolute top-4 right-4 text-[#6B7280] hover:text-[#EF4444] text-xl transition-colors bg-white dark:bg-gray-800 rounded-full p-1 shadow-sm border border-[#E5E7EB] dark:border-gray-600"
            >
              <FaTimes />
            </button>
          </div>
        </div>
      )}

      {/* Response File Modal */}
      {responseFileModalOpen && currentResponseFile && (
        <div className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm flex items-center justify-center p-4">
          <div className="relative bg-white rounded-xl shadow-2xl w-full max-w-4xl max-h-[90vh] flex flex-col dark:bg-gray-800 dark:text-white border border-[#E5E7EB] dark:border-gray-700">
            <div className="flex justify-between items-center p-4 border-b border-[#E5E7EB] dark:border-gray-700 bg-[#FAF8FF] dark:bg-gray-800 rounded-t-xl">
              <h3 className="text-lg font-bold cfg-heading text-[#1F2937] dark:text-white">
                {currentResponseFile.name}
              </h3>
              <button
                onClick={() => {
                  setResponseFileModalOpen(false);
                  URL.revokeObjectURL(currentResponseFile.url);
                  setCurrentResponseFile(null);
                }}
                className="text-[#6B7280] hover:text-[#EF4444] dark:hover:text-red-400 transition"
              >
                <FaTimes className="w-5 h-5" />
              </button>
            </div>

            <div className="flex-1 overflow-auto p-4 flex items-center justify-center bg-gray-50 dark:bg-gray-900">
              {currentResponseFile.type === "image" ? (
                <img
                  src={currentResponseFile.url}
                  alt="File preview"
                  className="max-w-full max-h-[70vh] object-contain shadow-sm rounded border border-gray-200 dark:border-gray-700"
                />
              ) : currentResponseFile.type === "pdf" ? (
                <iframe
                  src={`${currentResponseFile.url}#toolbar=0`}
                  className="w-full h-[70vh] border-none rounded shadow-sm"
                  title="PDF preview"
                />
              ) : currentResponseFile.type === "video" ? (
                <video
                  controls
                  className="w-full max-h-[70vh] rounded shadow-sm"
                >
                  <source
                    src={currentResponseFile.url}
                    type={`video/${currentResponseFile.name.split(".").pop()}`}
                  />
                  Your browser does not support the video tag.
                </video>
              ) : currentResponseFile.type === "audio" ? (
                <audio controls className="w-full max-w-md">
                  <source
                    src={currentResponseFile.url}
                    type={`audio/${currentResponseFile.name.split(".").pop()}`}
                  />
                  Your browser does not support the audio element.
                </audio>
              ) : currentResponseFile.type === "office" ? (
                <iframe
                  src={getOfficeViewerUrl(currentResponseFile.url)}
                  className="w-full h-[70vh] border-none rounded shadow-sm"
                  title="Office document preview"
                  allowFullScreen
                />
              ) : currentResponseFile.type === "text" ? (
                <iframe
                  src={currentResponseFile.url}
                  className="w-full h-[70vh] border-none rounded bg-white dark:bg-gray-800 shadow-sm"
                  title="Text preview"
                />
              ) : (
                <div className="text-center p-8 bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700">
                  <p className="text-[#6B7280] font-medium mb-4 dark:text-gray-300">
                    Preview not available for this file type
                  </p>
                  <button
                    onClick={() =>
                      downloadResponseAttachment(
                        selectedIssue.issueId,
                        issueResponses.find(
                          (r) =>
                            r.attachment &&
                            r.attachment.includes(currentResponseFile.name)
                        )?.id,
                        currentResponseFile.name
                      )
                    }
                    className="px-5 py-2.5 bg-[#673AB7] text-white font-semibold rounded-md hover:bg-[#5E35A6] shadow-md transition"
                  >
                    Download File
                  </button>
                </div>
              )}
            </div>

            <div className="flex justify-end p-4 border-t border-[#E5E7EB] dark:border-gray-700 bg-white dark:bg-gray-800 rounded-b-xl">
              <button
                onClick={() =>
                  downloadResponseAttachment(
                    selectedIssue.issueId,
                    issueResponses.find(
                      (r) =>
                        r.attachment &&
                        r.attachment.includes(currentResponseFile.name)
                    )?.id,
                    currentResponseFile.name
                  )
                }
                className="px-5 py-2 bg-[#673AB7] text-white font-semibold rounded-md hover:bg-[#5E35A6] transition flex items-center gap-2"
              >
                <FaDownload /> Download
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {showDeleteModal && issueToDelete && (
        <div className="fixed inset-0 flex items-center justify-center bg-black/50 backdrop-blur-sm z-50">
          <div className="bg-white rounded-xl p-6 shadow-2xl w-full max-w-sm dark:bg-gray-800 dark:text-white border border-[#E5E7EB] dark:border-gray-700 transform transition-all scale-100">
            <h2 className="text-xl font-bold text-[#1F2937] mb-3 cfg-heading dark:text-white">
              Confirm Delete
            </h2>
            <p className="text-[#374151] mb-6 dark:text-gray-300 text-sm">
              Are you sure you want to delete this issue? This action cannot be
              undone.
            </p>
            <div className="flex justify-end space-x-3">
              <button
                className="px-4 py-2 font-semibold text-[#374151] bg-[#F3F4F6] border border-[#E5E7EB] rounded-md hover:bg-[#E5E7EB] transition dark:bg-gray-700 dark:text-gray-200 dark:border-gray-600 dark:hover:bg-gray-600"
                onClick={() => setShowDeleteModal(false)}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 font-semibold bg-[#EF4444] text-white rounded-md hover:bg-[#B91C1C] shadow-md transition"
                onClick={() => handleDeleteIssue(issueToDelete.issueId)}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Attachment View Modal */}
      {showAttachmentModal && currentAttachment && (
        <div className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-center justify-center p-4">
          <div className="relative bg-white rounded-xl shadow-2xl w-full max-w-5xl max-h-[90vh] flex flex-col dark:bg-gray-800 dark:text-white border border-[#E5E7EB] dark:border-gray-700">
            <div className="flex justify-between items-center p-4 border-b border-[#E5E7EB] dark:border-gray-700 bg-[#FAF8FF] dark:bg-gray-800 rounded-t-xl">
              <h3 className="text-lg font-bold cfg-heading truncate max-w-[80%] text-[#1F2937] dark:text-white">
                {currentAttachment.name}{" "}
                <span className="text-sm font-medium text-[#673AB7] dark:text-[#E9D5FF] ml-2 bg-[#F3E8FF] dark:bg-purple-900 px-2 py-0.5 rounded-full">
                  ({currentAttachment.index + 1}/{currentAttachment.total})
                </span>
              </h3>
              <button
                onClick={() => {
                  setShowAttachmentModal(false);
                  URL.revokeObjectURL(currentAttachment.url);
                  setCurrentAttachment(null);
                }}
                className="text-[#6B7280] hover:text-[#EF4444] dark:hover:text-red-400 p-1 transition"
              >
                <FaTimes className="w-5 h-5" />
              </button>
            </div>

            <div className="flex-1 overflow-auto p-4 flex items-center justify-center relative bg-gray-50 dark:bg-gray-900 min-h-[50vh]">
              {/* Navigation arrows */}
              {currentAttachment.total > 1 && (
                <>
                  {currentAttachment.index > 0 && (
                    <button
                      onClick={() => {
                        URL.revokeObjectURL(currentAttachment.url);
                        handleViewAttachment(
                          selectedIssue,
                          currentAttachment.index - 1
                        );
                      }}
                      className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white/80 dark:bg-black/50 text-[#673AB7] dark:text-white p-2.5 rounded-full hover:bg-white dark:hover:bg-black/70 hover:scale-110 shadow-lg border border-[#E5E7EB] dark:border-gray-600 transition z-10"
                    >
                      <FaChevronLeft className="w-5 h-5" />
                    </button>
                  )}
                  {currentAttachment.index < currentAttachment.total - 1 && (
                    <button
                      onClick={() => {
                        URL.revokeObjectURL(currentAttachment.url);
                        handleViewAttachment(
                          selectedIssue,
                          currentAttachment.index + 1
                        );
                      }}
                      className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white/80 dark:bg-black/50 text-[#673AB7] dark:text-white p-2.5 rounded-full hover:bg-white dark:hover:bg-black/70 hover:scale-110 shadow-lg border border-[#E5E7EB] dark:border-gray-600 transition z-10"
                    >
                      <FaChevronRight className="w-5 h-5" />
                    </button>
                  )}
                </>
              )}

              {/* File preview */}
              {currentAttachment.type === "image" ? (
                <img
                  src={currentAttachment.url}
                  alt="Attachment preview"
                  className="max-h-full max-w-full object-contain shadow-sm rounded"
                />
              ) : currentAttachment.type === "video" ? (
                <video
                  controls
                  className="w-full h-full max-h-[70vh] rounded shadow-sm"
                >
                  <source
                    src={currentAttachment.url}
                    type={`video/${currentAttachment.name.split(".").pop()}`}
                  />
                  Your browser does not support the video tag.
                </video>
              ) : currentAttachment.type === "audio" ? (
                <audio
                  controls
                  className="w-full max-w-md shadow-sm rounded-full"
                >
                  <source
                    src={currentAttachment.url}
                    type={`audio/${currentAttachment.name.split(".").pop()}`}
                  />
                  Your browser does not support the audio element.
                </audio>
              ) : currentAttachment.type === "pdf" ? (
                <iframe
                  src={`${currentAttachment.url}#toolbar=0`}
                  className="w-full h-full min-h-[60vh] border-none rounded shadow-sm bg-white"
                  title="PDF preview"
                />
              ) : currentAttachment.type === "text" ? (
                <iframe
                  src={currentAttachment.url}
                  className="w-full h-full min-h-[60vh] border border-[#E5E7EB] dark:border-gray-700 rounded shadow-sm bg-white dark:bg-gray-800"
                  title="Text preview"
                />
              ) : (
                <div className="flex flex-col items-center justify-center h-full p-8 bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700">
                  <FaEye className="w-12 h-12 text-[#E5E7EB] dark:text-gray-600 mb-4" />
                  <p className="text-[#6B7280] font-medium text-center dark:text-gray-300">
                    Preview not available for this file type
                  </p>
                </div>
              )}
            </div>

            <div className="mt-auto flex flex-col sm:flex-row justify-between items-center p-4 border-t border-[#E5E7EB] dark:border-gray-700 bg-white dark:bg-gray-800 rounded-b-xl gap-4">
              <div className="flex space-x-2 overflow-x-auto max-w-full pb-2 sm:pb-0 scrollbar-thin">
                {(selectedIssue?.attachments || []).map((file, idx) => (
                  <button
                    key={idx}
                    onClick={() => {
                      URL.revokeObjectURL(currentAttachment.url);
                      handleViewAttachment(selectedIssue, idx);
                    }}
                    className={`w-12 h-12 flex-shrink-0 flex items-center justify-center rounded-lg border-2 transition-all ${
                      idx === currentAttachment.index
                        ? "border-[#673AB7] bg-[#F3E8FF] dark:bg-purple-900/40 shadow-sm scale-105"
                        : "border-[#E5E7EB] hover:border-[#8B5CF6] hover:bg-[#FAF8FF] dark:border-gray-600 dark:hover:border-purple-500 dark:hover:bg-gray-700"
                    }`}
                    title={file}
                  >
                    {file.split(".").pop().toLowerCase() === "pdf" ? (
                      <span className="text-[#EF4444] font-bold text-xs">
                        PDF
                      </span>
                    ) : ["jpg", "jpeg", "png", "gif"].includes(
                        file.split(".").pop().toLowerCase()
                      ) ? (
                      <span className="text-[#10B981] font-bold text-xs">
                        IMG
                      </span>
                    ) : (
                      <span className="text-[#6B7280] dark:text-gray-300 font-bold text-xs truncate max-w-[40px]">
                        {file.split(".").pop().toUpperCase().substring(0, 3)}
                      </span>
                    )}
                  </button>
                ))}
              </div>
              <button
                onClick={() =>
                  handleDownloadAttachment(selectedIssue, currentAttachment.name)
                }
                className="px-5 py-2.5 w-full sm:w-auto bg-[#673AB7] text-white font-semibold rounded-md hover:bg-[#5E35A6] shadow-md transition flex items-center justify-center gap-2"
              >
                <FaDownload /> Download
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Status Update Modal */}
      {statusUpdateModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
          <div className="bg-white p-6 rounded-xl shadow-2xl w-full max-w-sm dark:bg-gray-800 dark:text-white border border-[#E5E7EB] dark:border-gray-700">
            <h2 className="text-xl font-bold mb-5 cfg-heading text-[#1F2937] dark:text-white">
              Update Issue Status
            </h2>

            <div className="mb-4">
              <label className="block text-[#374151] font-semibold text-sm mb-2 dark:text-gray-200">
                New Status:
              </label>
              <div className="p-2.5 bg-[#FAF8FF] text-[#673AB7] font-bold rounded-md border border-[#E9D5FF] dark:bg-purple-900/30 dark:border-purple-700 dark:text-purple-300">
                {selectedStatusUpdate.newStatus}
              </div>
            </div>

            <div className="mb-5">
              <label className="block text-[#374151] font-semibold text-sm mb-2 dark:text-gray-200">
                Remark:
              </label>
              <textarea
                className="w-full p-3 border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] text-sm dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                rows="4"
                placeholder="Enter remark for status change..."
                value={selectedStatusUpdate.remark}
                onChange={(e) =>
                  setSelectedStatusUpdate((prev) => ({
                    ...prev,
                    remark: e.target.value,
                  }))
                }
              />
            </div>

            <div className="flex justify-end space-x-3">
              <button
                className="px-4 py-2 font-semibold bg-[#F3F4F6] text-[#374151] border border-[#E5E7EB] rounded-md hover:bg-[#E5E7EB] transition dark:bg-gray-700 dark:text-gray-200 dark:border-gray-600 dark:hover:bg-gray-600"
                onClick={() => setStatusUpdateModalOpen(false)}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 font-semibold bg-[#673AB7] text-white rounded-md hover:bg-[#5E35A6] shadow-md transition"
                onClick={handleStatusUpdateSubmit}
              >
                Update Status
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Edit Response Modal */}
      {editModalData && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex justify-center items-center z-50 p-4">
          <div className="bg-white rounded-xl w-full max-w-xl p-6 shadow-2xl relative dark:bg-gray-800 dark:text-white border border-[#E5E7EB] dark:border-gray-700">
            <h2 className="text-xl font-bold cfg-heading text-[#673AB7] dark:text-[#E9D5FF] mb-5 border-b border-[#E5E7EB] dark:border-gray-700 pb-3">
              Edit Response
            </h2>

            <label className="block mb-4 text-[#374151] font-semibold text-sm dark:text-gray-200">
              Content
              <textarea
                value={updatedContent}
                onChange={(e) => setUpdatedContent(e.target.value)}
                rows={4}
                className="w-full p-3 mt-1.5 border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] font-normal text-sm dark:bg-gray-700 dark:border-gray-600 dark:text-white"
              />
            </label>

            <label className="block mb-6 text-[#374151] font-semibold text-sm dark:text-gray-200">
              Upload New File{" "}
              <span className="text-[#6B7280] font-normal italic">
                (optional)
              </span>
              <input
                type="file"
                onChange={(e) => setUpdatedFile(e.target.files[0])}
                className="w-full mt-1.5 text-sm text-[#6B7280] file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-[#F3E8FF] file:text-[#673AB7] hover:file:bg-[#E9D5FF] transition dark:bg-gray-700 dark:text-white"
              />
            </label>

            <div className="flex justify-end gap-3 mt-4">
              <button
                className="px-5 py-2 font-semibold bg-[#F3F4F6] text-[#374151] border border-[#E5E7EB] rounded-md hover:bg-[#E5E7EB] transition dark:bg-gray-700 dark:text-gray-200 dark:border-gray-600 dark:hover:bg-gray-600"
                onClick={() => setEditModalData(null)}
              >
                Cancel
              </button>

              <button
                className="px-5 py-2 font-semibold bg-[#673AB7] text-white rounded-md hover:bg-[#5E35A6] shadow-md transition"
                onClick={handleUpdateResponse}
              >
                Update
              </button>
            </div>

            <button
              onClick={() => setEditModalData(null)}
              className="absolute top-4 right-4 text-[#6B7280] hover:text-[#EF4444] transition-colors bg-white dark:bg-gray-800 rounded-full p-1 border border-transparent hover:border-[#EF4444] hover:bg-[#FEF2F2] dark:hover:bg-gray-700"
            >
              <FaTimes className="w-5 h-5" />
            </button>
          </div>
        </div>
      )}
    </div>
  );
}